//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.17.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export abstract class BaseClient {
  transformResult(_url: string, _response: Response, processor: (_response: Response) => Promise<void | any>) {
    const { status } = _response;
    if (status === INTERGTRATION_API_ERROR_CDOE) {
      _response
        .clone()
        .text()
        .then((_responseText) => {
          const result = JSON.parse(_responseText) as IntegrationApiErrorRespponse;
          document.dispatchEvent(
            new CustomEvent<IntegrationApiErrorRespponse>(INTERGTRATION_API_ERROR_NOTIFICATION, { detail: result }),
          );

          return _responseText;
        })
        .catch((error) => {
          console.error(error);
        });
    }

    return processor(_response);
  }
}

export interface IBatteriesClient {

    getById(id: number): Promise<BatteryDto>;

    create(command: CreateBatteryCommand): Promise<BatteryDto>;

    update(command: UpdateBatteryCommand): Promise<BatteryDto>;
}

export class BatteriesClient extends BaseClient implements IBatteriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getById(id: number): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/api/batteries/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetById(_response));
        });
    }

    protected processGetById(response: Response): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BatteryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatteryDto>(null as any);
    }

    create(command: CreateBatteryCommand): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/api/batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BatteryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatteryDto>(null as any);
    }

    update(command: UpdateBatteryCommand): Promise<BatteryDto> {
        let url_ = this.baseUrl + "/api/batteries";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<BatteryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BatteryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<BatteryDto>(null as any);
    }
}

export interface ICustomDataProjectsClient {

    createCustomDataProject(command: CreateCustomDataProjectCommand): Promise<CustomDataProjectDto>;

    getCustomDataProjectById(projectId: number): Promise<CustomDataProjectDto>;

    getUploadDataUrls(projectId: string | null | undefined, projectName: string | null | undefined, fileType: string | null | undefined): Promise<UploadCustomDataPresignedUrlDto>;

    createCustomDataUploadPolling(command: CreateCustomDataUploadPollingCommand): Promise<string>;

    getCustomDataUploadStatusProjectById(projectId: number, originalProjectId: string | null): Promise<CustomDataUploadPollingDto>;

    getCustomDataUploadStatusByToken(token: string | null): Promise<CustomDataUploadPollingStatusDto>;
}

export class CustomDataProjectsClient extends BaseClient implements ICustomDataProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createCustomDataProject(command: CreateCustomDataProjectCommand): Promise<CustomDataProjectDto> {
        let url_ = this.baseUrl + "/api/customdataprojects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCustomDataProject(_response));
        });
    }

    protected processCreateCustomDataProject(response: Response): Promise<CustomDataProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomDataProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomDataProjectDto>(null as any);
    }

    getCustomDataProjectById(projectId: number): Promise<CustomDataProjectDto> {
        let url_ = this.baseUrl + "/api/customdataprojects/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomDataProjectById(_response));
        });
    }

    protected processGetCustomDataProjectById(response: Response): Promise<CustomDataProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomDataProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomDataProjectDto>(null as any);
    }

    getUploadDataUrls(projectId: string | null | undefined, projectName: string | null | undefined, fileType: string | null | undefined): Promise<UploadCustomDataPresignedUrlDto> {
        let url_ = this.baseUrl + "/api/customdataprojects/data-upload-urls?";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (projectName !== undefined && projectName !== null)
            url_ += "ProjectName=" + encodeURIComponent("" + projectName) + "&";
        if (fileType !== undefined && fileType !== null)
            url_ += "FileType=" + encodeURIComponent("" + fileType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUploadDataUrls(_response));
        });
    }

    protected processGetUploadDataUrls(response: Response): Promise<UploadCustomDataPresignedUrlDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UploadCustomDataPresignedUrlDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UploadCustomDataPresignedUrlDto>(null as any);
    }

    createCustomDataUploadPolling(command: CreateCustomDataUploadPollingCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/customdataprojects/createpolling";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCustomDataUploadPolling(_response));
        });
    }

    protected processCreateCustomDataUploadPolling(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getCustomDataUploadStatusProjectById(projectId: number, originalProjectId: string | null): Promise<CustomDataUploadPollingDto> {
        let url_ = this.baseUrl + "/api/customdataprojects/status/{projectId}/{originalProjectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (originalProjectId === undefined || originalProjectId === null)
            throw new Error("The parameter 'originalProjectId' must be defined.");
        url_ = url_.replace("{originalProjectId}", encodeURIComponent("" + originalProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomDataUploadStatusProjectById(_response));
        });
    }

    protected processGetCustomDataUploadStatusProjectById(response: Response): Promise<CustomDataUploadPollingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomDataUploadPollingDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomDataUploadPollingDto>(null as any);
    }

    getCustomDataUploadStatusByToken(token: string | null): Promise<CustomDataUploadPollingStatusDto> {
        let url_ = this.baseUrl + "/api/customdataprojects/polling-status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCustomDataUploadStatusByToken(_response));
        });
    }

    protected processGetCustomDataUploadStatusByToken(response: Response): Promise<CustomDataUploadPollingStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CustomDataUploadPollingStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CustomDataUploadPollingStatusDto>(null as any);
    }
}

export interface IDatasetPageClient {

    datasetDictionary(request: GetDatasetPageDictionariesQuery): Promise<PaginatedDtoOfVariableDto>;

    datasetExcludedVariablesDictionary(request: GetExcludeDatasetPageDictionariesQuery): Promise<PaginatedDtoOfVariableDto>;

    createOrUpdateDatasetsSettings(command: UpdateProjectSettingsCommand): Promise<void>;

    addOrUpdateExcludedDatasetsSettings(command: AddOrUpdateExcludedProjectSettingsCommand): Promise<void>;

    removeExcludedDatasetsSettings(command: RemoveExcludedProjectSettingsCommand): Promise<void>;

    getDatasetProjectSettingsByProjectId(projectId: number | undefined, encodedVersionId: string | null | undefined, stackId: number | null | undefined, modificationId: number | null | undefined): Promise<ProjectSettingsDto>;

    fetchIncludedFilterOptions(request: GetIncludeVariablesFilterOptionsQuery): Promise<VariablesFilterOptionsDto>;

    fetchExcludedFilterOptions(request: GetExcludeVariablesFilterOptionsQuery): Promise<VariablesFilterOptionsDto>;

    getExistingDatasets(): Promise<DatasetlistDto[]>;

    clearDataDictionary(id: number, versionId: string | null, stackId: number | null | undefined): Promise<NoData>;
}

export class DatasetPageClient extends BaseClient implements IDatasetPageClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    datasetDictionary(request: GetDatasetPageDictionariesQuery): Promise<PaginatedDtoOfVariableDto> {
        let url_ = this.baseUrl + "/api/datasetpage/includedvariables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDatasetDictionary(_response));
        });
    }

    protected processDatasetDictionary(response: Response): Promise<PaginatedDtoOfVariableDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDtoOfVariableDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDtoOfVariableDto>(null as any);
    }

    datasetExcludedVariablesDictionary(request: GetExcludeDatasetPageDictionariesQuery): Promise<PaginatedDtoOfVariableDto> {
        let url_ = this.baseUrl + "/api/datasetpage/excludedvariables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDatasetExcludedVariablesDictionary(_response));
        });
    }

    protected processDatasetExcludedVariablesDictionary(response: Response): Promise<PaginatedDtoOfVariableDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDtoOfVariableDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDtoOfVariableDto>(null as any);
    }

    createOrUpdateDatasetsSettings(command: UpdateProjectSettingsCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/datasetpage/settings/createorupdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOrUpdateDatasetsSettings(_response));
        });
    }

    protected processCreateOrUpdateDatasetsSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    addOrUpdateExcludedDatasetsSettings(command: AddOrUpdateExcludedProjectSettingsCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/datasetpage/addexcluded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processAddOrUpdateExcludedDatasetsSettings(_response));
        });
    }

    protected processAddOrUpdateExcludedDatasetsSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    removeExcludedDatasetsSettings(command: RemoveExcludedProjectSettingsCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/datasetpage/removeexcluded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRemoveExcludedDatasetsSettings(_response));
        });
    }

    protected processRemoveExcludedDatasetsSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getDatasetProjectSettingsByProjectId(projectId: number | undefined, encodedVersionId: string | null | undefined, stackId: number | null | undefined, modificationId: number | null | undefined): Promise<ProjectSettingsDto> {
        let url_ = this.baseUrl + "/api/datasetpage/settings/getbyprojectid?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (encodedVersionId !== undefined && encodedVersionId !== null)
            url_ += "EncodedVersionId=" + encodeURIComponent("" + encodedVersionId) + "&";
        if (stackId !== undefined && stackId !== null)
            url_ += "StackId=" + encodeURIComponent("" + stackId) + "&";
        if (modificationId !== undefined && modificationId !== null)
            url_ += "ModificationId=" + encodeURIComponent("" + modificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasetProjectSettingsByProjectId(_response));
        });
    }

    protected processGetDatasetProjectSettingsByProjectId(response: Response): Promise<ProjectSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectSettingsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSettingsDto>(null as any);
    }

    fetchIncludedFilterOptions(request: GetIncludeVariablesFilterOptionsQuery): Promise<VariablesFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/datasetpage/includedfilter/options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFetchIncludedFilterOptions(_response));
        });
    }

    protected processFetchIncludedFilterOptions(response: Response): Promise<VariablesFilterOptionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariablesFilterOptionsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariablesFilterOptionsDto>(null as any);
    }

    fetchExcludedFilterOptions(request: GetExcludeVariablesFilterOptionsQuery): Promise<VariablesFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/datasetpage/excludedfilter/options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFetchExcludedFilterOptions(_response));
        });
    }

    protected processFetchExcludedFilterOptions(response: Response): Promise<VariablesFilterOptionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariablesFilterOptionsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariablesFilterOptionsDto>(null as any);
    }

    getExistingDatasets(): Promise<DatasetlistDto[]> {
        let url_ = this.baseUrl + "/api/datasetpage/datasetlist";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetExistingDatasets(_response));
        });
    }

    protected processGetExistingDatasets(response: Response): Promise<DatasetlistDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DatasetlistDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DatasetlistDto[]>(null as any);
    }

    clearDataDictionary(id: number, versionId: string | null, stackId: number | null | undefined): Promise<NoData> {
        let url_ = this.baseUrl + "/api/datasetpage/{id}/datadictionary/{versionId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (stackId !== undefined && stackId !== null)
            url_ += "stackId=" + encodeURIComponent("" + stackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClearDataDictionary(_response));
        });
    }

    protected processClearDataDictionary(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }
}

export interface IDownloadHistoriesClient {

    getCsv(): Promise<FileResponse>;
}

export class DownloadHistoriesClient extends BaseClient implements IDownloadHistoriesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCsv(): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/downloadhistories/csv";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCsv(_response));
        });
    }

    protected processGetCsv(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface IExcludedVariablesClient {

    create(request: CreateExcludedVariableCommand): Promise<ExcludedVariableDto>;

    delete(request: DeleteExcludedVariableCommand): Promise<ExcludedVariableDto>;
}

export class ExcludedVariablesClient extends BaseClient implements IExcludedVariablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(request: CreateExcludedVariableCommand): Promise<ExcludedVariableDto> {
        let url_ = this.baseUrl + "/api/excludedvariables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ExcludedVariableDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExcludedVariableDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExcludedVariableDto>(null as any);
    }

    delete(request: DeleteExcludedVariableCommand): Promise<ExcludedVariableDto> {
        let url_ = this.baseUrl + "/api/excludedvariables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<ExcludedVariableDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExcludedVariableDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExcludedVariableDto>(null as any);
    }
}

export interface IForstaProjectsClient {

    create(command: CreateForstaProjectCommand): Promise<ForstaProjectDto>;

    createByDataset(command: CreateForstaProjectByDatasetCommand): Promise<ForstaProjectDto>;

    getLatestByProjectId(projectId: number, versionId: string | null, forstaProjectId: string | null, modificationId: number | null | undefined, stackId: number | null | undefined): Promise<ForstaProjectDto>;

    getStatusById(id: number): Promise<ForstaProjectStatusDto>;

    updateStatus(id: number, status: ForstaProjectStatuses, forstaProjectId: string | null | undefined): Promise<ForstaProjectStatusDto>;
}

export class ForstaProjectsClient extends BaseClient implements IForstaProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateForstaProjectCommand): Promise<ForstaProjectDto> {
        let url_ = this.baseUrl + "/api/forstaprojects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ForstaProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectDto>(null as any);
    }

    createByDataset(command: CreateForstaProjectByDatasetCommand): Promise<ForstaProjectDto> {
        let url_ = this.baseUrl + "/api/forstaprojects/create-by-dataset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateByDataset(_response));
        });
    }

    protected processCreateByDataset(response: Response): Promise<ForstaProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectDto>(null as any);
    }

    getLatestByProjectId(projectId: number, versionId: string | null, forstaProjectId: string | null, modificationId: number | null | undefined, stackId: number | null | undefined): Promise<ForstaProjectDto> {
        let url_ = this.baseUrl + "/api/forstaprojects/latest/{projectId}/{versionId}/{forstaProjectId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (forstaProjectId === undefined || forstaProjectId === null)
            throw new Error("The parameter 'forstaProjectId' must be defined.");
        url_ = url_.replace("{forstaProjectId}", encodeURIComponent("" + forstaProjectId));
        if (modificationId !== undefined && modificationId !== null)
            url_ += "modificationId=" + encodeURIComponent("" + modificationId) + "&";
        if (stackId !== undefined && stackId !== null)
            url_ += "stackId=" + encodeURIComponent("" + stackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetLatestByProjectId(_response));
        });
    }

    protected processGetLatestByProjectId(response: Response): Promise<ForstaProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectDto>(null as any);
    }

    getStatusById(id: number): Promise<ForstaProjectStatusDto> {
        let url_ = this.baseUrl + "/api/forstaprojects/status/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatusById(_response));
        });
    }

    protected processGetStatusById(response: Response): Promise<ForstaProjectStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectStatusDto>(null as any);
    }

    updateStatus(id: number, status: ForstaProjectStatuses, forstaProjectId: string | null | undefined): Promise<ForstaProjectStatusDto> {
        let url_ = this.baseUrl + "/api/forstaprojects/status/{id}/{status}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        if (forstaProjectId !== undefined && forstaProjectId !== null)
            url_ += "forstaProjectId=" + encodeURIComponent("" + forstaProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateStatus(_response));
        });
    }

    protected processUpdateStatus(response: Response): Promise<ForstaProjectStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectStatusDto>(null as any);
    }
}

export interface IInteractionLogClient {

    create(command: CreateInteractionLogCommand): Promise<void>;

    deleteInteractionLogsForSelectedEmail(command: DeleteInteractionLogsCommand): Promise<void>;

    recentInteractionLogs(pageSize: number | undefined, limitToDays: number | null | undefined): Promise<RecentInteractionsLogDto>;

    recentInteractionCount(limitToDays: number | null | undefined): Promise<number>;
}

export class InteractionLogClient extends BaseClient implements IInteractionLogClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(command: CreateInteractionLogCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/interactionlog/create";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    deleteInteractionLogsForSelectedEmail(command: DeleteInteractionLogsCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/interactionlog/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteInteractionLogsForSelectedEmail(_response));
        });
    }

    protected processDeleteInteractionLogsForSelectedEmail(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    recentInteractionLogs(pageSize: number | undefined, limitToDays: number | null | undefined): Promise<RecentInteractionsLogDto> {
        let url_ = this.baseUrl + "/api/interactionlog/recent-activity?";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
        if (limitToDays !== undefined && limitToDays !== null)
            url_ += "limitToDays=" + encodeURIComponent("" + limitToDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecentInteractionLogs(_response));
        });
    }

    protected processRecentInteractionLogs(response: Response): Promise<RecentInteractionsLogDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecentInteractionsLogDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecentInteractionsLogDto>(null as any);
    }

    recentInteractionCount(limitToDays: number | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/interactionlog/recent-activity-count?";
        if (limitToDays !== undefined && limitToDays !== null)
            url_ += "limitToDays=" + encodeURIComponent("" + limitToDays) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecentInteractionCount(_response));
        });
    }

    protected processRecentInteractionCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }
}

export interface IModificationFiltersClient {

    create(request: CreateModificationFiltersCommand): Promise<ModificationFilterDto>;

    update(command: UpdateModificationFilterCommand): Promise<ModificationFilterDto>;

    delete(command: DeleteModificationFilterCommand): Promise<DeletionFilterDto>;

    getVariableFilters(modificationId: number): Promise<ModificationFilterDto[]>;
}

export class ModificationFiltersClient extends BaseClient implements IModificationFiltersClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    create(request: CreateModificationFiltersCommand): Promise<ModificationFilterDto> {
        let url_ = this.baseUrl + "/api/modificationfilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ModificationFilterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationFilterDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationFilterDto>(null as any);
    }

    update(command: UpdateModificationFilterCommand): Promise<ModificationFilterDto> {
        let url_ = this.baseUrl + "/api/modificationfilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ModificationFilterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationFilterDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationFilterDto>(null as any);
    }

    delete(command: DeleteModificationFilterCommand): Promise<DeletionFilterDto> {
        let url_ = this.baseUrl + "/api/modificationfilters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "DELETE",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDelete(_response));
        });
    }

    protected processDelete(response: Response): Promise<DeletionFilterDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DeletionFilterDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DeletionFilterDto>(null as any);
    }

    getVariableFilters(modificationId: number): Promise<ModificationFilterDto[]> {
        let url_ = this.baseUrl + "/api/modificationfilters/{modificationId}";
        if (modificationId === undefined || modificationId === null)
            throw new Error("The parameter 'modificationId' must be defined.");
        url_ = url_.replace("{modificationId}", encodeURIComponent("" + modificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVariableFilters(_response));
        });
    }

    protected processGetVariableFilters(response: Response): Promise<ModificationFilterDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationFilterDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationFilterDto[]>(null as any);
    }
}

export interface IModificationsClient {

    createModification(request: CreateModificationCommand): Promise<ModificationDto>;

    rename(request: RenameModificationCommand): Promise<ModificationDto>;

    pushInstructions(modificationId: number): Promise<string>;

    getInstructionsJson(id: number): Promise<FileResponse>;

    getByProjectId(projectId: number, versionId: string | null): Promise<ModificationDto[]>;

    getRespondentFinishDate(projectId: string | null, versionId: string | null): Promise<RespondentDateModel>;

    importInstruction(srcProjectId: number, srcModificationId: number, destProjectId: number, destVersionId: string | null): Promise<ModificationDto>;

    getImportInstructions(srcProjectId: number, srcModificationId: number, destProjectId: number, destVersionId: string | null): Promise<ImportInstructionDto>;

    createSpssFile(command: CreateSpssFileByModificationIdCommand): Promise<EncodingFileDto>;

    createCsvFile(command: CreateCsvFileByModificationIdCommand): Promise<EncodingFileDto>;

    createDatasetCsvFile(command: CreateDatasetCsvFileByModificationIdCommand): Promise<EncodingFileDto>;

    createDatasetSpssFile(command: CreateDatasetSpssFileByModificationIdCommand): Promise<EncodingFileDto>;
}

export class ModificationsClient extends BaseClient implements IModificationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createModification(request: CreateModificationCommand): Promise<ModificationDto> {
        let url_ = this.baseUrl + "/api/modifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateModification(_response));
        });
    }

    protected processCreateModification(response: Response): Promise<ModificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationDto>(null as any);
    }

    rename(request: RenameModificationCommand): Promise<ModificationDto> {
        let url_ = this.baseUrl + "/api/modifications";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRename(_response));
        });
    }

    protected processRename(response: Response): Promise<ModificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationDto>(null as any);
    }

    pushInstructions(modificationId: number): Promise<string> {
        let url_ = this.baseUrl + "/api/modifications/instructions/{modificationId}";
        if (modificationId === undefined || modificationId === null)
            throw new Error("The parameter 'modificationId' must be defined.");
        url_ = url_.replace("{modificationId}", encodeURIComponent("" + modificationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPushInstructions(_response));
        });
    }

    protected processPushInstructions(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    getInstructionsJson(id: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/modifications/instructions/json/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetInstructionsJson(_response));
        });
    }

    protected processGetInstructionsJson(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    getByProjectId(projectId: number, versionId: string | null): Promise<ModificationDto[]> {
        let url_ = this.baseUrl + "/api/modifications/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByProjectId(_response));
        });
    }

    protected processGetByProjectId(response: Response): Promise<ModificationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationDto[];
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationDto[]>(null as any);
    }

    getRespondentFinishDate(projectId: string | null, versionId: string | null): Promise<RespondentDateModel> {
        let url_ = this.baseUrl + "/api/modifications/respondent-finish-date/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRespondentFinishDate(_response));
        });
    }

    protected processGetRespondentFinishDate(response: Response): Promise<RespondentDateModel> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RespondentDateModel;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RespondentDateModel>(null as any);
    }

    importInstruction(srcProjectId: number, srcModificationId: number, destProjectId: number, destVersionId: string | null): Promise<ModificationDto> {
        let url_ = this.baseUrl + "/api/modifications/instructions/{srcProjectId}/{srcModificationId}/{destProjectId}/{destVersionId}";
        if (srcProjectId === undefined || srcProjectId === null)
            throw new Error("The parameter 'srcProjectId' must be defined.");
        url_ = url_.replace("{srcProjectId}", encodeURIComponent("" + srcProjectId));
        if (srcModificationId === undefined || srcModificationId === null)
            throw new Error("The parameter 'srcModificationId' must be defined.");
        url_ = url_.replace("{srcModificationId}", encodeURIComponent("" + srcModificationId));
        if (destProjectId === undefined || destProjectId === null)
            throw new Error("The parameter 'destProjectId' must be defined.");
        url_ = url_.replace("{destProjectId}", encodeURIComponent("" + destProjectId));
        if (destVersionId === undefined || destVersionId === null)
            throw new Error("The parameter 'destVersionId' must be defined.");
        url_ = url_.replace("{destVersionId}", encodeURIComponent("" + destVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "POST",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processImportInstruction(_response));
        });
    }

    protected processImportInstruction(response: Response): Promise<ModificationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationDto>(null as any);
    }

    getImportInstructions(srcProjectId: number, srcModificationId: number, destProjectId: number, destVersionId: string | null): Promise<ImportInstructionDto> {
        let url_ = this.baseUrl + "/api/modifications/instructions/{srcProjectId}/{srcModificationId}/{destProjectId}/{destVersionId}";
        if (srcProjectId === undefined || srcProjectId === null)
            throw new Error("The parameter 'srcProjectId' must be defined.");
        url_ = url_.replace("{srcProjectId}", encodeURIComponent("" + srcProjectId));
        if (srcModificationId === undefined || srcModificationId === null)
            throw new Error("The parameter 'srcModificationId' must be defined.");
        url_ = url_.replace("{srcModificationId}", encodeURIComponent("" + srcModificationId));
        if (destProjectId === undefined || destProjectId === null)
            throw new Error("The parameter 'destProjectId' must be defined.");
        url_ = url_.replace("{destProjectId}", encodeURIComponent("" + destProjectId));
        if (destVersionId === undefined || destVersionId === null)
            throw new Error("The parameter 'destVersionId' must be defined.");
        url_ = url_.replace("{destVersionId}", encodeURIComponent("" + destVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetImportInstructions(_response));
        });
    }

    protected processGetImportInstructions(response: Response): Promise<ImportInstructionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ImportInstructionDto;
            return result200;
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ImportInstructionDto>(null as any);
    }

    createSpssFile(command: CreateSpssFileByModificationIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modifications/spss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSpssFile(_response));
        });
    }

    protected processCreateSpssFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createCsvFile(command: CreateCsvFileByModificationIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modifications/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCsvFile(_response));
        });
    }

    protected processCreateCsvFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createDatasetCsvFile(command: CreateDatasetCsvFileByModificationIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modifications/datasetcsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDatasetCsvFile(_response));
        });
    }

    protected processCreateDatasetCsvFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createDatasetSpssFile(command: CreateDatasetSpssFileByModificationIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modifications/datasetspss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDatasetSpssFile(_response));
        });
    }

    protected processCreateDatasetSpssFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }
}

export interface IModificationStacksClient {

    getByProjectId(projectId: number, versionId: string | null): Promise<ModificationStackDto[]>;

    getStackSpecs(stackId: number): Promise<ModificationStackSpecDto>;

    getStackSpecsDownload(stackId: number): Promise<FileResponse>;

    create(command: CreateModificationStackCommand): Promise<ModificationStackDto>;

    update(command: UpdateModificationStackCommand): Promise<ModificationStackDto>;

    publish(command: PublishModificationStackCommand): Promise<PublishedStackDto>;

    validate(command: ValidateModificationStackCommand): Promise<StackValidationStatusDto>;

    getStatus(token: string | null): Promise<StackStatusDto>;

    createSpssFile(command: CreateSpssFileByStackIdCommand): Promise<EncodingFileDto>;

    createCsvFile(command: CreateCsvFileByStackIdCommand): Promise<EncodingFileDto>;

    createDatasetCsvFile(command: CreateDatasetCsvFileByStackIdCommand): Promise<EncodingFileDto>;

    createDatasetSpssFile(command: CreateDatasetSpssFileByStackIdCommand): Promise<EncodingFileDto>;
}

export class ModificationStacksClient extends BaseClient implements IModificationStacksClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByProjectId(projectId: number, versionId: string | null): Promise<ModificationStackDto[]> {
        let url_ = this.baseUrl + "/api/modificationstacks/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByProjectId(_response));
        });
    }

    protected processGetByProjectId(response: Response): Promise<ModificationStackDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationStackDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationStackDto[]>(null as any);
    }

    getStackSpecs(stackId: number): Promise<ModificationStackSpecDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/{stackId}/specs";
        if (stackId === undefined || stackId === null)
            throw new Error("The parameter 'stackId' must be defined.");
        url_ = url_.replace("{stackId}", encodeURIComponent("" + stackId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStackSpecs(_response));
        });
    }

    protected processGetStackSpecs(response: Response): Promise<ModificationStackSpecDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationStackSpecDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationStackSpecDto>(null as any);
    }

    getStackSpecsDownload(stackId: number): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/modificationstacks/{stackId}/downloadspecs";
        if (stackId === undefined || stackId === null)
            throw new Error("The parameter 'stackId' must be defined.");
        url_ = url_.replace("{stackId}", encodeURIComponent("" + stackId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/octet-stream"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStackSpecsDownload(_response));
        });
    }

    protected processGetStackSpecsDownload(response: Response): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return response.blob().then(blob => { return { fileName: fileName, data: blob, status: status, headers: _headers }; });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    create(command: CreateModificationStackCommand): Promise<ModificationStackDto> {
        let url_ = this.baseUrl + "/api/modificationstacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreate(_response));
        });
    }

    protected processCreate(response: Response): Promise<ModificationStackDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationStackDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationStackDto>(null as any);
    }

    update(command: UpdateModificationStackCommand): Promise<ModificationStackDto> {
        let url_ = this.baseUrl + "/api/modificationstacks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdate(_response));
        });
    }

    protected processUpdate(response: Response): Promise<ModificationStackDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ModificationStackDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ModificationStackDto>(null as any);
    }

    publish(command: PublishModificationStackCommand): Promise<PublishedStackDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/publishing";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPublish(_response));
        });
    }

    protected processPublish(response: Response): Promise<PublishedStackDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PublishedStackDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PublishedStackDto>(null as any);
    }

    validate(command: ValidateModificationStackCommand): Promise<StackValidationStatusDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/validation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processValidate(_response));
        });
    }

    protected processValidate(response: Response): Promise<StackValidationStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StackValidationStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StackValidationStatusDto>(null as any);
    }

    getStatus(token: string | null): Promise<StackStatusDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStatus(_response));
        });
    }

    protected processGetStatus(response: Response): Promise<StackStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StackStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StackStatusDto>(null as any);
    }

    createSpssFile(command: CreateSpssFileByStackIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/spss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSpssFile(_response));
        });
    }

    protected processCreateSpssFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createCsvFile(command: CreateCsvFileByStackIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCsvFile(_response));
        });
    }

    protected processCreateCsvFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createDatasetCsvFile(command: CreateDatasetCsvFileByStackIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/datasetcsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDatasetCsvFile(_response));
        });
    }

    protected processCreateDatasetCsvFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createDatasetSpssFile(command: CreateDatasetSpssFileByStackIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/modificationstacks/datasetspss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDatasetSpssFile(_response));
        });
    }

    protected processCreateDatasetSpssFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }
}

export interface IOECodingClient {

    createOECodingVariable(request: CreateOECodingVariableCommand): Promise<OpenEndCodedVariableDto>;

    getOECodedVariablesForProject(projectId: number, version: string | null): Promise<OpenEndCodedVariableDto[]>;
}

export class OECodingClient extends BaseClient implements IOECodingClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createOECodingVariable(request: CreateOECodingVariableCommand): Promise<OpenEndCodedVariableDto> {
        let url_ = this.baseUrl + "/api/oecoding";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOECodingVariable(_response));
        });
    }

    protected processCreateOECodingVariable(response: Response): Promise<OpenEndCodedVariableDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpenEndCodedVariableDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenEndCodedVariableDto>(null as any);
    }

    getOECodedVariablesForProject(projectId: number, version: string | null): Promise<OpenEndCodedVariableDto[]> {
        let url_ = this.baseUrl + "/api/oecoding/{projectId}/{version}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOECodedVariablesForProject(_response));
        });
    }

    protected processGetOECodedVariablesForProject(response: Response): Promise<OpenEndCodedVariableDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OpenEndCodedVariableDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OpenEndCodedVariableDto[]>(null as any);
    }
}

export interface IOriginProjectsClient {

    getAll(sourceId: number): Promise<OriginProjectDto[]>;

    getROriginProjects(): Promise<OriginProjectDto[]>;
}

export class OriginProjectsClient extends BaseClient implements IOriginProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(sourceId: number): Promise<OriginProjectDto[]> {
        let url_ = this.baseUrl + "/api/originprojects/{sourceId}";
        if (sourceId === undefined || sourceId === null)
            throw new Error("The parameter 'sourceId' must be defined.");
        url_ = url_.replace("{sourceId}", encodeURIComponent("" + sourceId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<OriginProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OriginProjectDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OriginProjectDto[]>(null as any);
    }

    getROriginProjects(): Promise<OriginProjectDto[]> {
        let url_ = this.baseUrl + "/api/originprojects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetROriginProjects(_response));
        });
    }

    protected processGetROriginProjects(response: Response): Promise<OriginProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OriginProjectDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OriginProjectDto[]>(null as any);
    }
}

export interface IPowerBIProjectsClient {

    export(command: ExportPowerBIProjectCommand): Promise<PowerBIFileDto>;
}

export class PowerBIProjectsClient extends BaseClient implements IPowerBIProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    export(command: ExportPowerBIProjectCommand): Promise<PowerBIFileDto> {
        let url_ = this.baseUrl + "/api/powerbiprojects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExport(_response));
        });
    }

    protected processExport(response: Response): Promise<PowerBIFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PowerBIFileDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PowerBIFileDto>(null as any);
    }
}

export interface IProjectIntegrationsClient {

    getByProjectId(projectId: number): Promise<ProjectIntegrationDto[]>;

    createPowerBIIntegration(integrationCommand: CreatePowerBIIntegrationCommand): Promise<number>;

    createForstaVisualizationsIntegration(integrationCommand: CreateForstaIntegrationCommand): Promise<number>;

    pushForstaVisualizations(command: PushForstaVisualizationIntegrationCommand): Promise<ForstaProjectDto>;

    updateIntegrationForstaVizStatus(command: UpdateForstaVisulizationStatusCommand): Promise<NoData>;

    createAscribeIntegration(integrationCommand: CreateAscribeIntegrationCommand): Promise<number>;

    downloadPowerBiFiles(command: DownloadPowerBICommand): Promise<PowerBIFileDto>;

    createWalrIntegration(integrationCommand: CreateWalrIntegrationCommand): Promise<CreateWalrIntegrationResponseDto>;

    exportWalrMetadata(walrExportMetadataCommand: WalrExportMetadataCommand): Promise<WalrExportMetadataResponseDto>;

    exportWalrData(walrExportDataCommand: WalrExportDataCommand): Promise<WalrExportDataResponseDto>;

    getWalrDataExportStatus(token: string | null, walrProjectId: string | null): Promise<WalrExportStatusResponseDto>;

    updateForstaVisualizationStatus(forstaProjectId: string | null, integrationId: number): Promise<ForstaProjectStatusDto>;
}

export class ProjectIntegrationsClient extends BaseClient implements IProjectIntegrationsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getByProjectId(projectId: number): Promise<ProjectIntegrationDto[]> {
        let url_ = this.baseUrl + "/api/projectintegrations/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByProjectId(_response));
        });
    }

    protected processGetByProjectId(response: Response): Promise<ProjectIntegrationDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectIntegrationDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectIntegrationDto[]>(null as any);
    }

    createPowerBIIntegration(integrationCommand: CreatePowerBIIntegrationCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/projectintegrations/create-powerbi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integrationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreatePowerBIIntegration(_response));
        });
    }

    protected processCreatePowerBIIntegration(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createForstaVisualizationsIntegration(integrationCommand: CreateForstaIntegrationCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/projectintegrations/create-forstavisualizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integrationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateForstaVisualizationsIntegration(_response));
        });
    }

    protected processCreateForstaVisualizationsIntegration(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    pushForstaVisualizations(command: PushForstaVisualizationIntegrationCommand): Promise<ForstaProjectDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/push-forstavisualizations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPushForstaVisualizations(_response));
        });
    }

    protected processPushForstaVisualizations(response: Response): Promise<ForstaProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectDto>(null as any);
    }

    updateIntegrationForstaVizStatus(command: UpdateForstaVisulizationStatusCommand): Promise<NoData> {
        let url_ = this.baseUrl + "/api/projectintegrations";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateIntegrationForstaVizStatus(_response));
        });
    }

    protected processUpdateIntegrationForstaVizStatus(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    createAscribeIntegration(integrationCommand: CreateAscribeIntegrationCommand): Promise<number> {
        let url_ = this.baseUrl + "/api/projectintegrations/create-ascribe";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integrationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateAscribeIntegration(_response));
        });
    }

    protected processCreateAscribeIntegration(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    downloadPowerBiFiles(command: DownloadPowerBICommand): Promise<PowerBIFileDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/download-powerbi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadPowerBiFiles(_response));
        });
    }

    protected processDownloadPowerBiFiles(response: Response): Promise<PowerBIFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PowerBIFileDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PowerBIFileDto>(null as any);
    }

    createWalrIntegration(integrationCommand: CreateWalrIntegrationCommand): Promise<CreateWalrIntegrationResponseDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/create-walr";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(integrationCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateWalrIntegration(_response));
        });
    }

    protected processCreateWalrIntegration(response: Response): Promise<CreateWalrIntegrationResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateWalrIntegrationResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateWalrIntegrationResponseDto>(null as any);
    }

    exportWalrMetadata(walrExportMetadataCommand: WalrExportMetadataCommand): Promise<WalrExportMetadataResponseDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/walr-metadata-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walrExportMetadataCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportWalrMetadata(_response));
        });
    }

    protected processExportWalrMetadata(response: Response): Promise<WalrExportMetadataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WalrExportMetadataResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalrExportMetadataResponseDto>(null as any);
    }

    exportWalrData(walrExportDataCommand: WalrExportDataCommand): Promise<WalrExportDataResponseDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/walr-data-export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(walrExportDataCommand);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processExportWalrData(_response));
        });
    }

    protected processExportWalrData(response: Response): Promise<WalrExportDataResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WalrExportDataResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalrExportDataResponseDto>(null as any);
    }

    getWalrDataExportStatus(token: string | null, walrProjectId: string | null): Promise<WalrExportStatusResponseDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/walr-export-status/{token}/{walrProjectId}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        if (walrProjectId === undefined || walrProjectId === null)
            throw new Error("The parameter 'walrProjectId' must be defined.");
        url_ = url_.replace("{walrProjectId}", encodeURIComponent("" + walrProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWalrDataExportStatus(_response));
        });
    }

    protected processGetWalrDataExportStatus(response: Response): Promise<WalrExportStatusResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WalrExportStatusResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalrExportStatusResponseDto>(null as any);
    }

    updateForstaVisualizationStatus(forstaProjectId: string | null, integrationId: number): Promise<ForstaProjectStatusDto> {
        let url_ = this.baseUrl + "/api/projectintegrations/status/{forstaProjectId}/{integrationId}";
        if (forstaProjectId === undefined || forstaProjectId === null)
            throw new Error("The parameter 'forstaProjectId' must be defined.");
        url_ = url_.replace("{forstaProjectId}", encodeURIComponent("" + forstaProjectId));
        if (integrationId === undefined || integrationId === null)
            throw new Error("The parameter 'integrationId' must be defined.");
        url_ = url_.replace("{integrationId}", encodeURIComponent("" + integrationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PATCH",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateForstaVisualizationStatus(_response));
        });
    }

    protected processUpdateForstaVisualizationStatus(response: Response): Promise<ForstaProjectStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ForstaProjectStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ForstaProjectStatusDto>(null as any);
    }
}

export interface IProjectsClient {

    getProjectById(id: number): Promise<ProjectDto>;

    deleteProject(id: number): Promise<NoData>;

    getProjectByOriginProjectId(projectNumber: string | null): Promise<MergedProjectDto>;

    getAllProjects(): Promise<ShortProjectDto[]>;

    createProject(request: CreateProjectCommand): Promise<EntityIdDtoOfInteger>;

    updateProject(request: UpdateProjectCommand): Promise<NoData>;

    createProjectFromEncoded(request: CreateProjectFromEncodedCommand): Promise<MergedProjectDto>;

    page(request: PageContextOfProjectFilter): Promise<PaginatedDtoOfMergedProjectDto>;

    updateProjectLatestVersion(projectId: number): Promise<NoData>;

    updateSettings(command: UpdateProjectSettingsCommand): Promise<void>;

    getSettings(projectId: number | undefined, encodedVersionId: string | null | undefined, stackId: number | null | undefined, modificationId: number | null | undefined): Promise<ProjectSettingsDto>;

    createOrUpdateProjectVersion(request: CreateOrUpdateProjectVersionCommand): Promise<ProjectVersionDto>;

    getProjectVersions(id: number): Promise<ProjectVersionDto[]>;
}

export class ProjectsClient extends BaseClient implements IProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getProjectById(id: number): Promise<ProjectDto> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectById(_response));
        });
    }

    protected processGetProjectById(response: Response): Promise<ProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectDto>(null as any);
    }

    deleteProject(id: number): Promise<NoData> {
        let url_ = this.baseUrl + "/api/projects/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteProject(_response));
        });
    }

    protected processDeleteProject(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    getProjectByOriginProjectId(projectNumber: string | null): Promise<MergedProjectDto> {
        let url_ = this.baseUrl + "/api/projects/by-origin/{projectNumber}";
        if (projectNumber === undefined || projectNumber === null)
            throw new Error("The parameter 'projectNumber' must be defined.");
        url_ = url_.replace("{projectNumber}", encodeURIComponent("" + projectNumber));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectByOriginProjectId(_response));
        });
    }

    protected processGetProjectByOriginProjectId(response: Response): Promise<MergedProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MergedProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergedProjectDto>(null as any);
    }

    getAllProjects(): Promise<ShortProjectDto[]> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllProjects(_response));
        });
    }

    protected processGetAllProjects(response: Response): Promise<ShortProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ShortProjectDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ShortProjectDto[]>(null as any);
    }

    createProject(request: CreateProjectCommand): Promise<EntityIdDtoOfInteger> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProject(_response));
        });
    }

    protected processCreateProject(response: Response): Promise<EntityIdDtoOfInteger> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EntityIdDtoOfInteger;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EntityIdDtoOfInteger>(null as any);
    }

    updateProject(request: UpdateProjectCommand): Promise<NoData> {
        let url_ = this.baseUrl + "/api/projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProject(_response));
        });
    }

    protected processUpdateProject(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    createProjectFromEncoded(request: CreateProjectFromEncodedCommand): Promise<MergedProjectDto> {
        let url_ = this.baseUrl + "/api/projects/encoded";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateProjectFromEncoded(_response));
        });
    }

    protected processCreateProjectFromEncoded(response: Response): Promise<MergedProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as MergedProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<MergedProjectDto>(null as any);
    }

    page(request: PageContextOfProjectFilter): Promise<PaginatedDtoOfMergedProjectDto> {
        let url_ = this.baseUrl + "/api/projects/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPage(_response));
        });
    }

    protected processPage(response: Response): Promise<PaginatedDtoOfMergedProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDtoOfMergedProjectDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDtoOfMergedProjectDto>(null as any);
    }

    updateProjectLatestVersion(projectId: number): Promise<NoData> {
        let url_ = this.baseUrl + "/api/projects/updateencodingversion/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "PUT",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateProjectLatestVersion(_response));
        });
    }

    protected processUpdateProjectLatestVersion(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    updateSettings(command: UpdateProjectSettingsCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/projects/settings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSettings(_response));
        });
    }

    protected processUpdateSettings(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getSettings(projectId: number | undefined, encodedVersionId: string | null | undefined, stackId: number | null | undefined, modificationId: number | null | undefined): Promise<ProjectSettingsDto> {
        let url_ = this.baseUrl + "/api/projects/settings?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (encodedVersionId !== undefined && encodedVersionId !== null)
            url_ += "EncodedVersionId=" + encodeURIComponent("" + encodedVersionId) + "&";
        if (stackId !== undefined && stackId !== null)
            url_ += "StackId=" + encodeURIComponent("" + stackId) + "&";
        if (modificationId !== undefined && modificationId !== null)
            url_ += "ModificationId=" + encodeURIComponent("" + modificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSettings(_response));
        });
    }

    protected processGetSettings(response: Response): Promise<ProjectSettingsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectSettingsDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSettingsDto>(null as any);
    }

    createOrUpdateProjectVersion(request: CreateOrUpdateProjectVersionCommand): Promise<ProjectVersionDto> {
        let url_ = this.baseUrl + "/api/projects/version";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOrUpdateProjectVersion(_response));
        });
    }

    protected processCreateOrUpdateProjectVersion(response: Response): Promise<ProjectVersionDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectVersionDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectVersionDto>(null as any);
    }

    getProjectVersions(id: number): Promise<ProjectVersionDto[]> {
        let url_ = this.baseUrl + "/api/projects/{id}/versions";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectVersions(_response));
        });
    }

    protected processGetProjectVersions(response: Response): Promise<ProjectVersionDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectVersionDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectVersionDto[]>(null as any);
    }
}

export interface IProjectsDataClient {

    pageDataDictionary(request: GetDataDictionariesPageQuery): Promise<PaginatedDtoOfVariablesBatteryDto>;

    getBatteries(projectId: number, encodedVersionId: string | null, stackId: number | null | undefined, modificationId: number | null | undefined): Promise<OriginBatteryDto[]>;

    getRespondentsCount(projectId: number, versionId: string | null, modificationId: number | null | undefined): Promise<number>;

    createSpssFile(command: CreateSpssFileByProjectIdCommand): Promise<EncodingFileDto>;

    createDatasetSpssFile(command: CreateDatasetSpssFileByProjectIdCommand): Promise<EncodingFileDto>;

    createCsvFile(command: CreateCsvFileByProjectIdCommand): Promise<EncodingFileDto>;

    createDatasetCsvFile(command: CreateDatasetCsvFileByProjectIdCommand): Promise<EncodingFileDto>;

    clearDataDictionary(id: number, versionId: string | null, stackId: number | null | undefined): Promise<NoData>;

    fetchFilterOptions(request: GetVariablesFilterOptionsQuery): Promise<VariablesFilterOptionsDto>;

    getCompositeMetaData(projectId: number, version: string | null): Promise<CompositeProjectMetadataDto>;

    updateCompositeMetadata(command: UpdateCompositeMetadataCommand): Promise<CompositeProjectMetadataDto>;

    compositeMergeProjects(request: CompositeMergeProjectCommand): Promise<CompositeMergeResponseDto>;

    getCompositeMergeStatus(token: string | null | undefined, compositeProjectId: string | null | undefined): Promise<CompositeMergeStatusDto>;

    getEncodedDataDownloadStatus(token: string | null | undefined, projectId: string | null | undefined): Promise<EncodedDataDownloadStatusDto>;

    getProjectMetadata(projectId: string | null): Promise<DataCollectionVariableModel[]>;
}

export class ProjectsDataClient extends BaseClient implements IProjectsDataClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    pageDataDictionary(request: GetDataDictionariesPageQuery): Promise<PaginatedDtoOfVariablesBatteryDto> {
        let url_ = this.baseUrl + "/api/projectsdata/page";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processPageDataDictionary(_response));
        });
    }

    protected processPageDataDictionary(response: Response): Promise<PaginatedDtoOfVariablesBatteryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as PaginatedDtoOfVariablesBatteryDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<PaginatedDtoOfVariablesBatteryDto>(null as any);
    }

    getBatteries(projectId: number, encodedVersionId: string | null, stackId: number | null | undefined, modificationId: number | null | undefined): Promise<OriginBatteryDto[]> {
        let url_ = this.baseUrl + "/api/projectsdata/batteries/{projectId}/{encodedVersionId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (stackId !== undefined && stackId !== null)
            url_ += "stackId=" + encodeURIComponent("" + stackId) + "&";
        if (modificationId !== undefined && modificationId !== null)
            url_ += "modificationId=" + encodeURIComponent("" + modificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBatteries(_response));
        });
    }

    protected processGetBatteries(response: Response): Promise<OriginBatteryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as OriginBatteryDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<OriginBatteryDto[]>(null as any);
    }

    getRespondentsCount(projectId: number, versionId: string | null, modificationId: number | null | undefined): Promise<number> {
        let url_ = this.baseUrl + "/api/projectsdata/respondents/{projectId}/{versionId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (modificationId !== undefined && modificationId !== null)
            url_ += "modificationId=" + encodeURIComponent("" + modificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRespondentsCount(_response));
        });
    }

    protected processGetRespondentsCount(response: Response): Promise<number> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as number;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<number>(null as any);
    }

    createSpssFile(command: CreateSpssFileByProjectIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/projectsdata/spss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSpssFile(_response));
        });
    }

    protected processCreateSpssFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createDatasetSpssFile(command: CreateDatasetSpssFileByProjectIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/projectsdata/datasetspss";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDatasetSpssFile(_response));
        });
    }

    protected processCreateDatasetSpssFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createCsvFile(command: CreateCsvFileByProjectIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/projectsdata/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateCsvFile(_response));
        });
    }

    protected processCreateCsvFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    createDatasetCsvFile(command: CreateDatasetCsvFileByProjectIdCommand): Promise<EncodingFileDto> {
        let url_ = this.baseUrl + "/api/projectsdata/datasetcsv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateDatasetCsvFile(_response));
        });
    }

    protected processCreateDatasetCsvFile(response: Response): Promise<EncodingFileDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingFileDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodingFileDto>(null as any);
    }

    clearDataDictionary(id: number, versionId: string | null, stackId: number | null | undefined): Promise<NoData> {
        let url_ = this.baseUrl + "/api/projectsdata/{id}/datadictionary/{versionId}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (stackId !== undefined && stackId !== null)
            url_ += "stackId=" + encodeURIComponent("" + stackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processClearDataDictionary(_response));
        });
    }

    protected processClearDataDictionary(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    fetchFilterOptions(request: GetVariablesFilterOptionsQuery): Promise<VariablesFilterOptionsDto> {
        let url_ = this.baseUrl + "/api/projectsdata/filter/options";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processFetchFilterOptions(_response));
        });
    }

    protected processFetchFilterOptions(response: Response): Promise<VariablesFilterOptionsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariablesFilterOptionsDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariablesFilterOptionsDto>(null as any);
    }

    getCompositeMetaData(projectId: number, version: string | null): Promise<CompositeProjectMetadataDto> {
        let url_ = this.baseUrl + "/api/projectsdata/composite-metadata/{projectId}/{version}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompositeMetaData(_response));
        });
    }

    protected processGetCompositeMetaData(response: Response): Promise<CompositeProjectMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompositeProjectMetadataDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositeProjectMetadataDto>(null as any);
    }

    updateCompositeMetadata(command: UpdateCompositeMetadataCommand): Promise<CompositeProjectMetadataDto> {
        let url_ = this.baseUrl + "/api/projectsdata/update-composite-metadata";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateCompositeMetadata(_response));
        });
    }

    protected processUpdateCompositeMetadata(response: Response): Promise<CompositeProjectMetadataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompositeProjectMetadataDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositeProjectMetadataDto>(null as any);
    }

    compositeMergeProjects(request: CompositeMergeProjectCommand): Promise<CompositeMergeResponseDto> {
        let url_ = this.baseUrl + "/api/projectsdata/composite-merge-projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCompositeMergeProjects(_response));
        });
    }

    protected processCompositeMergeProjects(response: Response): Promise<CompositeMergeResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompositeMergeResponseDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositeMergeResponseDto>(null as any);
    }

    getCompositeMergeStatus(token: string | null | undefined, compositeProjectId: string | null | undefined): Promise<CompositeMergeStatusDto> {
        let url_ = this.baseUrl + "/api/projectsdata/composite-merge-status?";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (compositeProjectId !== undefined && compositeProjectId !== null)
            url_ += "CompositeProjectId=" + encodeURIComponent("" + compositeProjectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCompositeMergeStatus(_response));
        });
    }

    protected processGetCompositeMergeStatus(response: Response): Promise<CompositeMergeStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CompositeMergeStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CompositeMergeStatusDto>(null as any);
    }

    getEncodedDataDownloadStatus(token: string | null | undefined, projectId: string | null | undefined): Promise<EncodedDataDownloadStatusDto> {
        let url_ = this.baseUrl + "/api/projectsdata/encoded-data-download-status?";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (projectId !== undefined && projectId !== null)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetEncodedDataDownloadStatus(_response));
        });
    }

    protected processGetEncodedDataDownloadStatus(response: Response): Promise<EncodedDataDownloadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodedDataDownloadStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EncodedDataDownloadStatusDto>(null as any);
    }

    getProjectMetadata(projectId: string | null): Promise<DataCollectionVariableModel[]> {
        let url_ = this.baseUrl + "/api/projectsdata/metadata/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetProjectMetadata(_response));
        });
    }

    protected processGetProjectMetadata(response: Response): Promise<DataCollectionVariableModel[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DataCollectionVariableModel[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DataCollectionVariableModel[]>(null as any);
    }
}

export interface IProjectSourcesClient {

    getAll(): Promise<ProjectSourceDto[]>;
}

export class ProjectSourcesClient extends BaseClient implements IProjectSourcesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getAll(): Promise<ProjectSourceDto[]> {
        let url_ = this.baseUrl + "/api/projectsources";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<ProjectSourceDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ProjectSourceDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ProjectSourceDto[]>(null as any);
    }
}

export interface IRelabeledVariablesClient {

    editLabel(command: EditVariableLabelCommand): Promise<RelabeledVariableDto>;
}

export class RelabeledVariablesClient extends BaseClient implements IRelabeledVariablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    editLabel(command: EditVariableLabelCommand): Promise<RelabeledVariableDto> {
        let url_ = this.baseUrl + "/api/relabeledvariables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditLabel(_response));
        });
    }

    protected processEditLabel(response: Response): Promise<RelabeledVariableDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelabeledVariableDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelabeledVariableDto>(null as any);
    }
}

export interface ISimilarityReportClient {

    createSimilarityReport(command: CreateSimilarityReportCommand): Promise<string>;

    updateSimilarityReportStatus(command: UpdateSimilarityReportHistoryCommand): Promise<SimilarityReportHistoryDto>;

    createSimilarityReportIncludedVariables(command: CreateSimilarityReportIncludedVariableCommand): Promise<string>;

    downloadSimilarityReport(command: DownloadSimilarityReportCommand): Promise<SimilarityReportDto>;

    getSimilarityReportStatus(token: string | null): Promise<SimilarityReportStatusDto>;

    getSimilarityReportHistory(projectId: number, modificationId: number, versionId: string | null): Promise<SimilarityReportHistoryDto>;

    deleteSimilarityReportHistory(projectId: number, modificationId: number, versionId: string | null): Promise<SimilarityReportHistoryDto>;

    saveSimilarityConfigurations(command: SaveSimilarityConfigCommand): Promise<Unit>;

    getAllSavedSimilarityConfigs(projectId: number | undefined, versionId: string | null | undefined): Promise<string[]>;

    getSavedSimilarityConfigsByName(projectId: number | undefined, versionId: string | null | undefined, similarityConfigsName: string | null | undefined): Promise<SimilarityFormConfigurationsDto>;

    createSimilarityReportOpenEnds(command: CreateSimilarityReportOpenEndsCommand): Promise<string>;

    downloadSimilarityReportOpenEnds(command: DownloadSimilarityReportOpenEndsCommand): Promise<SimilarityReportDto>;

    getSimilarityReportOpenEndsStatus(token: string | null): Promise<SimilarityReportStatusDto>;
}

export class SimilarityReportClient extends BaseClient implements ISimilarityReportClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createSimilarityReport(command: CreateSimilarityReportCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/similarityreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSimilarityReport(_response));
        });
    }

    protected processCreateSimilarityReport(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    updateSimilarityReportStatus(command: UpdateSimilarityReportHistoryCommand): Promise<SimilarityReportHistoryDto> {
        let url_ = this.baseUrl + "/api/similarityreport";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateSimilarityReportStatus(_response));
        });
    }

    protected processUpdateSimilarityReportStatus(response: Response): Promise<SimilarityReportHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportHistoryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportHistoryDto>(null as any);
    }

    createSimilarityReportIncludedVariables(command: CreateSimilarityReportIncludedVariableCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/similarityreport/includedvariable";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSimilarityReportIncludedVariables(_response));
        });
    }

    protected processCreateSimilarityReportIncludedVariables(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    downloadSimilarityReport(command: DownloadSimilarityReportCommand): Promise<SimilarityReportDto> {
        let url_ = this.baseUrl + "/api/similarityreport/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadSimilarityReport(_response));
        });
    }

    protected processDownloadSimilarityReport(response: Response): Promise<SimilarityReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportDto>(null as any);
    }

    getSimilarityReportStatus(token: string | null): Promise<SimilarityReportStatusDto> {
        let url_ = this.baseUrl + "/api/similarityreport/status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSimilarityReportStatus(_response));
        });
    }

    protected processGetSimilarityReportStatus(response: Response): Promise<SimilarityReportStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportStatusDto>(null as any);
    }

    getSimilarityReportHistory(projectId: number, modificationId: number, versionId: string | null): Promise<SimilarityReportHistoryDto> {
        let url_ = this.baseUrl + "/api/similarityreport/{projectId}/{modificationId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (modificationId === undefined || modificationId === null)
            throw new Error("The parameter 'modificationId' must be defined.");
        url_ = url_.replace("{modificationId}", encodeURIComponent("" + modificationId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSimilarityReportHistory(_response));
        });
    }

    protected processGetSimilarityReportHistory(response: Response): Promise<SimilarityReportHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportHistoryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportHistoryDto>(null as any);
    }

    deleteSimilarityReportHistory(projectId: number, modificationId: number, versionId: string | null): Promise<SimilarityReportHistoryDto> {
        let url_ = this.baseUrl + "/api/similarityreport/{projectId}/{modificationId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (modificationId === undefined || modificationId === null)
            throw new Error("The parameter 'modificationId' must be defined.");
        url_ = url_.replace("{modificationId}", encodeURIComponent("" + modificationId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "DELETE",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDeleteSimilarityReportHistory(_response));
        });
    }

    protected processDeleteSimilarityReportHistory(response: Response): Promise<SimilarityReportHistoryDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportHistoryDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportHistoryDto>(null as any);
    }

    saveSimilarityConfigurations(command: SaveSimilarityConfigCommand): Promise<Unit> {
        let url_ = this.baseUrl + "/api/similarityreport/save-configs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processSaveSimilarityConfigurations(_response));
        });
    }

    protected processSaveSimilarityConfigurations(response: Response): Promise<Unit> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as Unit;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<Unit>(null as any);
    }

    getAllSavedSimilarityConfigs(projectId: number | undefined, versionId: string | null | undefined): Promise<string[]> {
        let url_ = this.baseUrl + "/api/similarityreport/allconfigs?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (versionId !== undefined && versionId !== null)
            url_ += "VersionId=" + encodeURIComponent("" + versionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllSavedSimilarityConfigs(_response));
        });
    }

    protected processGetAllSavedSimilarityConfigs(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getSavedSimilarityConfigsByName(projectId: number | undefined, versionId: string | null | undefined, similarityConfigsName: string | null | undefined): Promise<SimilarityFormConfigurationsDto> {
        let url_ = this.baseUrl + "/api/similarityreport/saved-configs?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (versionId !== undefined && versionId !== null)
            url_ += "VersionId=" + encodeURIComponent("" + versionId) + "&";
        if (similarityConfigsName !== undefined && similarityConfigsName !== null)
            url_ += "SimilarityConfigsName=" + encodeURIComponent("" + similarityConfigsName) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSavedSimilarityConfigsByName(_response));
        });
    }

    protected processGetSavedSimilarityConfigsByName(response: Response): Promise<SimilarityFormConfigurationsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityFormConfigurationsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityFormConfigurationsDto>(null as any);
    }

    createSimilarityReportOpenEnds(command: CreateSimilarityReportOpenEndsCommand): Promise<string> {
        let url_ = this.baseUrl + "/api/similarityreport/openends";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateSimilarityReportOpenEnds(_response));
        });
    }

    protected processCreateSimilarityReportOpenEnds(response: Response): Promise<string> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string>(null as any);
    }

    downloadSimilarityReportOpenEnds(command: DownloadSimilarityReportOpenEndsCommand): Promise<SimilarityReportDto> {
        let url_ = this.baseUrl + "/api/similarityreport/openends/file";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadSimilarityReportOpenEnds(_response));
        });
    }

    protected processDownloadSimilarityReportOpenEnds(response: Response): Promise<SimilarityReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportDto>(null as any);
    }

    getSimilarityReportOpenEndsStatus(token: string | null): Promise<SimilarityReportStatusDto> {
        let url_ = this.baseUrl + "/api/similarityreport/openends/status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetSimilarityReportOpenEndsStatus(_response));
        });
    }

    protected processGetSimilarityReportOpenEndsStatus(response: Response): Promise<SimilarityReportStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as SimilarityReportStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<SimilarityReportStatusDto>(null as any);
    }
}

export interface ITextProjectSettingsClient {

    createOrUpdateTextProjectSetting(request: CreateOrUpdateTextProjectSettingCommand): Promise<TextProjectSettingDto>;

    getTextProjectSettingByProjectId(projectId: number): Promise<TextProjectSettingDto>;
}

export class TextProjectSettingsClient extends BaseClient implements ITextProjectSettingsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createOrUpdateTextProjectSetting(request: CreateOrUpdateTextProjectSettingCommand): Promise<TextProjectSettingDto> {
        let url_ = this.baseUrl + "/api/textprojectsettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateOrUpdateTextProjectSetting(_response));
        });
    }

    protected processCreateOrUpdateTextProjectSetting(response: Response): Promise<TextProjectSettingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextProjectSettingDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextProjectSettingDto>(null as any);
    }

    getTextProjectSettingByProjectId(projectId: number): Promise<TextProjectSettingDto> {
        let url_ = this.baseUrl + "/api/textprojectsettings/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTextProjectSettingByProjectId(_response));
        });
    }

    protected processGetTextProjectSettingByProjectId(response: Response): Promise<TextProjectSettingDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextProjectSettingDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextProjectSettingDto>(null as any);
    }
}

export interface ITextVariablesClient {

    getTextVariables(projectId: number, version: string | null): Promise<TextVariableDto[]>;

    downloadCsv(command: DownloadTextVariablesCsvCommand): Promise<ExportResponseDto>;

    downloadOpenEndCsv(command: DownloadTextVariablesCsvCommand): Promise<ExportResponseDto>;

    getOpenEndVariables(projectId: number, encodedVersionId: string | null): Promise<TextVariableDto[]>;

    getOpenEndVariableWaves(projectId: number): Promise<string[]>;

    initiateTranslation(command: InitiateTranslationCommand): Promise<InitiateTranslateJobDto>;

    downloadTranslation(projectId: number): Promise<DownloadTranslationDto>;

    initiateRelevancyChecker(command: InitiateRelevancyCheckerCommand): Promise<InitiateRelevancyCheckerDto>;

    initiateDownloadRelevancyChecker(request: DownloadRelevancyCheckerQuery): Promise<DownloadRelevancyCheckerDto>;

    downloadRelevancyCheckerReport(projectId: number | undefined, version: string | null | undefined, token: string | null | undefined): Promise<DownloadRelevancyReportDto>;

    getTextDataDownloadStatus(token: string | null | undefined, projectId: number | undefined): Promise<TextDataDownloadStatusDto>;

    getRelevancyCheckerInitiateStatus(projectId: number | undefined, token: string | null | undefined): Promise<RelevancyCheckerInitiateStatusDto>;

    getRelevancyCheckerDownloadStatus(projectId: number | undefined, token: string | null | undefined): Promise<RelevancyCheckerDownloadStatusDto>;

    getTranslationDownloadStatus(projectId: number | undefined, token: string | null | undefined): Promise<TranslationDownloadStatusDto>;

    getTranslateInitiateStatus(projectId: number | undefined, token: string | null | undefined): Promise<TranslateInitiateStatusDto>;

    getDownloadStatus(token: string | null | undefined): Promise<TextDataDownloadStatusDto>;
}

export class TextVariablesClient extends BaseClient implements ITextVariablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getTextVariables(projectId: number, version: string | null): Promise<TextVariableDto[]> {
        let url_ = this.baseUrl + "/api/textvariables/{projectId}/{version}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (version === undefined || version === null)
            throw new Error("The parameter 'version' must be defined.");
        url_ = url_.replace("{version}", encodeURIComponent("" + version));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTextVariables(_response));
        });
    }

    protected processGetTextVariables(response: Response): Promise<TextVariableDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextVariableDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextVariableDto[]>(null as any);
    }

    downloadCsv(command: DownloadTextVariablesCsvCommand): Promise<ExportResponseDto> {
        let url_ = this.baseUrl + "/api/textvariables/csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadCsv(_response));
        });
    }

    protected processDownloadCsv(response: Response): Promise<ExportResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportResponseDto>(null as any);
    }

    downloadOpenEndCsv(command: DownloadTextVariablesCsvCommand): Promise<ExportResponseDto> {
        let url_ = this.baseUrl + "/api/textvariables/openend-csv";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadOpenEndCsv(_response));
        });
    }

    protected processDownloadOpenEndCsv(response: Response): Promise<ExportResponseDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ExportResponseDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ExportResponseDto>(null as any);
    }

    getOpenEndVariables(projectId: number, encodedVersionId: string | null): Promise<TextVariableDto[]> {
        let url_ = this.baseUrl + "/api/textvariables/openend-variables/{projectId}/{encodedVersionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOpenEndVariables(_response));
        });
    }

    protected processGetOpenEndVariables(response: Response): Promise<TextVariableDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextVariableDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextVariableDto[]>(null as any);
    }

    getOpenEndVariableWaves(projectId: number): Promise<string[]> {
        let url_ = this.baseUrl + "/api/textvariables/waves/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetOpenEndVariableWaves(_response));
        });
    }

    protected processGetOpenEndVariableWaves(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    initiateTranslation(command: InitiateTranslationCommand): Promise<InitiateTranslateJobDto> {
        let url_ = this.baseUrl + "/api/textvariables/initiate-translate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiateTranslation(_response));
        });
    }

    protected processInitiateTranslation(response: Response): Promise<InitiateTranslateJobDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InitiateTranslateJobDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiateTranslateJobDto>(null as any);
    }

    downloadTranslation(projectId: number): Promise<DownloadTranslationDto> {
        let url_ = this.baseUrl + "/api/textvariables/transalation/download/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadTranslation(_response));
        });
    }

    protected processDownloadTranslation(response: Response): Promise<DownloadTranslationDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadTranslationDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadTranslationDto>(null as any);
    }

    initiateRelevancyChecker(command: InitiateRelevancyCheckerCommand): Promise<InitiateRelevancyCheckerDto> {
        let url_ = this.baseUrl + "/api/textvariables/initiate-relevancychecker";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiateRelevancyChecker(_response));
        });
    }

    protected processInitiateRelevancyChecker(response: Response): Promise<InitiateRelevancyCheckerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as InitiateRelevancyCheckerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<InitiateRelevancyCheckerDto>(null as any);
    }

    initiateDownloadRelevancyChecker(request: DownloadRelevancyCheckerQuery): Promise<DownloadRelevancyCheckerDto> {
        let url_ = this.baseUrl + "/api/textvariables/relevancy-report/download";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processInitiateDownloadRelevancyChecker(_response));
        });
    }

    protected processInitiateDownloadRelevancyChecker(response: Response): Promise<DownloadRelevancyCheckerDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadRelevancyCheckerDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadRelevancyCheckerDto>(null as any);
    }

    downloadRelevancyCheckerReport(projectId: number | undefined, version: string | null | undefined, token: string | null | undefined): Promise<DownloadRelevancyReportDto> {
        let url_ = this.baseUrl + "/api/textvariables/relevancy-report/download?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (version !== undefined && version !== null)
            url_ += "Version=" + encodeURIComponent("" + version) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processDownloadRelevancyCheckerReport(_response));
        });
    }

    protected processDownloadRelevancyCheckerReport(response: Response): Promise<DownloadRelevancyReportDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as DownloadRelevancyReportDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<DownloadRelevancyReportDto>(null as any);
    }

    getTextDataDownloadStatus(token: string | null | undefined, projectId: number | undefined): Promise<TextDataDownloadStatusDto> {
        let url_ = this.baseUrl + "/api/textvariables/text-data-download-status?";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTextDataDownloadStatus(_response));
        });
    }

    protected processGetTextDataDownloadStatus(response: Response): Promise<TextDataDownloadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextDataDownloadStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextDataDownloadStatusDto>(null as any);
    }

    getRelevancyCheckerInitiateStatus(projectId: number | undefined, token: string | null | undefined): Promise<RelevancyCheckerInitiateStatusDto> {
        let url_ = this.baseUrl + "/api/textvariables/relevancy-checker-initiate-status?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRelevancyCheckerInitiateStatus(_response));
        });
    }

    protected processGetRelevancyCheckerInitiateStatus(response: Response): Promise<RelevancyCheckerInitiateStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelevancyCheckerInitiateStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelevancyCheckerInitiateStatusDto>(null as any);
    }

    getRelevancyCheckerDownloadStatus(projectId: number | undefined, token: string | null | undefined): Promise<RelevancyCheckerDownloadStatusDto> {
        let url_ = this.baseUrl + "/api/textvariables/relevancy-checker-download-status?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetRelevancyCheckerDownloadStatus(_response));
        });
    }

    protected processGetRelevancyCheckerDownloadStatus(response: Response): Promise<RelevancyCheckerDownloadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RelevancyCheckerDownloadStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RelevancyCheckerDownloadStatusDto>(null as any);
    }

    getTranslationDownloadStatus(projectId: number | undefined, token: string | null | undefined): Promise<TranslationDownloadStatusDto> {
        let url_ = this.baseUrl + "/api/textvariables/translation-download-status?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslationDownloadStatus(_response));
        });
    }

    protected processGetTranslationDownloadStatus(response: Response): Promise<TranslationDownloadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TranslationDownloadStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslationDownloadStatusDto>(null as any);
    }

    getTranslateInitiateStatus(projectId: number | undefined, token: string | null | undefined): Promise<TranslateInitiateStatusDto> {
        let url_ = this.baseUrl + "/api/textvariables/translate-initiate-status?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetTranslateInitiateStatus(_response));
        });
    }

    protected processGetTranslateInitiateStatus(response: Response): Promise<TranslateInitiateStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TranslateInitiateStatusDto;
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TranslateInitiateStatusDto>(null as any);
    }

    getDownloadStatus(token: string | null | undefined): Promise<TextDataDownloadStatusDto> {
        let url_ = this.baseUrl + "/api/textvariables/polling/download-status?";
        if (token !== undefined && token !== null)
            url_ += "Token=" + encodeURIComponent("" + token) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDownloadStatus(_response));
        });
    }

    protected processGetDownloadStatus(response: Response): Promise<TextDataDownloadStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as TextDataDownloadStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<TextDataDownloadStatusDto>(null as any);
    }
}

export interface IUnslotSpecsClient {

    createUnslotSpecs(command: CreateUnslotSpecCommand): Promise<CreateUnslotDto>;

    getUnslotStatusByProject(projectId: number, versionId: string | null): Promise<UnslotSpecStatusDto>;

    getUnslotStatus(token: string | null): Promise<UnslotSpecStatusDto>;

    getUnslotReportHistory(projectId: number, versionId: string | null): Promise<UnslotSpecHistoryDto[]>;

    getUnslotFormData(projectId: number, versionId: string | null, unslotSpecName: string | null): Promise<UnslotSpecFormDataDto>;
}

export class UnslotSpecsClient extends BaseClient implements IUnslotSpecsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createUnslotSpecs(command: CreateUnslotSpecCommand): Promise<CreateUnslotDto> {
        let url_ = this.baseUrl + "/api/unslotspecs";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateUnslotSpecs(_response));
        });
    }

    protected processCreateUnslotSpecs(response: Response): Promise<CreateUnslotDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CreateUnslotDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CreateUnslotDto>(null as any);
    }

    getUnslotStatusByProject(projectId: number, versionId: string | null): Promise<UnslotSpecStatusDto> {
        let url_ = this.baseUrl + "/api/unslotspecs/statusbyproject/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUnslotStatusByProject(_response));
        });
    }

    protected processGetUnslotStatusByProject(response: Response): Promise<UnslotSpecStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnslotSpecStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnslotSpecStatusDto>(null as any);
    }

    getUnslotStatus(token: string | null): Promise<UnslotSpecStatusDto> {
        let url_ = this.baseUrl + "/api/unslotspecs/status/{token}";
        if (token === undefined || token === null)
            throw new Error("The parameter 'token' must be defined.");
        url_ = url_.replace("{token}", encodeURIComponent("" + token));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUnslotStatus(_response));
        });
    }

    protected processGetUnslotStatus(response: Response): Promise<UnslotSpecStatusDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnslotSpecStatusDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnslotSpecStatusDto>(null as any);
    }

    getUnslotReportHistory(projectId: number, versionId: string | null): Promise<UnslotSpecHistoryDto[]> {
        let url_ = this.baseUrl + "/api/unslotspecs/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUnslotReportHistory(_response));
        });
    }

    protected processGetUnslotReportHistory(response: Response): Promise<UnslotSpecHistoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnslotSpecHistoryDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnslotSpecHistoryDto[]>(null as any);
    }

    getUnslotFormData(projectId: number, versionId: string | null, unslotSpecName: string | null): Promise<UnslotSpecFormDataDto> {
        let url_ = this.baseUrl + "/api/unslotspecs/{projectId}/{versionId}/{unslotSpecName}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        if (unslotSpecName === undefined || unslotSpecName === null)
            throw new Error("The parameter 'unslotSpecName' must be defined.");
        url_ = url_.replace("{unslotSpecName}", encodeURIComponent("" + unslotSpecName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetUnslotFormData(_response));
        });
    }

    protected processGetUnslotFormData(response: Response): Promise<UnslotSpecFormDataDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as UnslotSpecFormDataDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<UnslotSpecFormDataDto>(null as any);
    }
}

export interface IVariablesClient {

    getCategories(projectId: number, encodedVersionId: string | null, variableName: string | null, modificationId: number | null | undefined, stackId: number | null | undefined): Promise<VariableCategoryDto[]>;

    getCategoriesForVariables(projectId: number, encodedVersionId: string | null, modificationId: number | null | undefined, stackId: number | null | undefined, variableNames: string[]): Promise<VariableCategoriesListDto[]>;

    getScalarStats(projectId: number, encodedVersionId: string | null, variableName: string | null): Promise<ScalarVariableStatsDto>;

    getCategoricalStats(projectId: number, encodedVersionId: string | null, variableName: string | null): Promise<CategoricalVariableStatsDto>;

    getAll(request: GetAllVariablesQuery): Promise<string[]>;

    getAllDatasetVariables(request: GetAllDatasetVariablesQuery): Promise<string[]>;

    getVariableNameBattery(request: GetVariableNameBatteryListQuery): Promise<VariableNameBatteryDto[]>;

    getDatasetVariableNameBattery(request: GetDatasetVariableNameBatteryQuery): Promise<VariableNameBatteryDto[]>;

    getStems(projectId: number, versionId: string | null): Promise<VariableStemDto[]>;

    getAssigners(projectId: number, encodedVersionId: string | null, modificationId: number | null | undefined): Promise<AssignerHintsDto>;

    getBrands(projectId: number, encodedVersionId: string | null, assigner: string | null): Promise<string[]>;

    recodeVariable(request: RecodeVariableCommand): Promise<RecodeDto>;

    editDisplayLabels(request: EditDisplayLabelsCommand): Promise<EditedVariablesDto>;

    resetVariableChanges(request: ResetVariableChangesCommand): Promise<void>;

    getStackables(projectId: number, encodedVersionId: string | null, assigner: string | null): Promise<StackablesDto>;
}

export class VariablesClient extends BaseClient implements IVariablesClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    getCategories(projectId: number, encodedVersionId: string | null, variableName: string | null, modificationId: number | null | undefined, stackId: number | null | undefined): Promise<VariableCategoryDto[]> {
        let url_ = this.baseUrl + "/api/variables/{projectId}/{encodedVersionId}/categories/{variableName}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (variableName === undefined || variableName === null)
            throw new Error("The parameter 'variableName' must be defined.");
        url_ = url_.replace("{variableName}", encodeURIComponent("" + variableName));
        if (modificationId !== undefined && modificationId !== null)
            url_ += "modificationId=" + encodeURIComponent("" + modificationId) + "&";
        if (stackId !== undefined && stackId !== null)
            url_ += "stackId=" + encodeURIComponent("" + stackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCategories(_response));
        });
    }

    protected processGetCategories(response: Response): Promise<VariableCategoryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariableCategoryDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableCategoryDto[]>(null as any);
    }

    getCategoriesForVariables(projectId: number, encodedVersionId: string | null, modificationId: number | null | undefined, stackId: number | null | undefined, variableNames: string[]): Promise<VariableCategoriesListDto[]> {
        let url_ = this.baseUrl + "/api/variables/{projectId}/{encodedVersionId}/categories-for-variables?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (modificationId !== undefined && modificationId !== null)
            url_ += "modificationId=" + encodeURIComponent("" + modificationId) + "&";
        if (stackId !== undefined && stackId !== null)
            url_ += "stackId=" + encodeURIComponent("" + stackId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(variableNames);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCategoriesForVariables(_response));
        });
    }

    protected processGetCategoriesForVariables(response: Response): Promise<VariableCategoriesListDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariableCategoriesListDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableCategoriesListDto[]>(null as any);
    }

    getScalarStats(projectId: number, encodedVersionId: string | null, variableName: string | null): Promise<ScalarVariableStatsDto> {
        let url_ = this.baseUrl + "/api/variables/{projectId}/{encodedVersionId}/stats/scalar{variableName}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (variableName === undefined || variableName === null)
            throw new Error("The parameter 'variableName' must be defined.");
        url_ = url_.replace("{variableName}", encodeURIComponent("" + variableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetScalarStats(_response));
        });
    }

    protected processGetScalarStats(response: Response): Promise<ScalarVariableStatsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ScalarVariableStatsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<ScalarVariableStatsDto>(null as any);
    }

    getCategoricalStats(projectId: number, encodedVersionId: string | null, variableName: string | null): Promise<CategoricalVariableStatsDto> {
        let url_ = this.baseUrl + "/api/variables/{projectId}/{encodedVersionId}/stats/categorical/{variableName}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (variableName === undefined || variableName === null)
            throw new Error("The parameter 'variableName' must be defined.");
        url_ = url_.replace("{variableName}", encodeURIComponent("" + variableName));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetCategoricalStats(_response));
        });
    }

    protected processGetCategoricalStats(response: Response): Promise<CategoricalVariableStatsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as CategoricalVariableStatsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<CategoricalVariableStatsDto>(null as any);
    }

    getAll(request: GetAllVariablesQuery): Promise<string[]> {
        let url_ = this.baseUrl + "/api/variables/all";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAll(_response));
        });
    }

    protected processGetAll(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getAllDatasetVariables(request: GetAllDatasetVariablesQuery): Promise<string[]> {
        let url_ = this.baseUrl + "/api/variables/all-dataset-variables";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllDatasetVariables(_response));
        });
    }

    protected processGetAllDatasetVariables(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    getVariableNameBattery(request: GetVariableNameBatteryListQuery): Promise<VariableNameBatteryDto[]> {
        let url_ = this.baseUrl + "/api/variables/all-variable-battery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetVariableNameBattery(_response));
        });
    }

    protected processGetVariableNameBattery(response: Response): Promise<VariableNameBatteryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariableNameBatteryDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableNameBatteryDto[]>(null as any);
    }

    getDatasetVariableNameBattery(request: GetDatasetVariableNameBatteryQuery): Promise<VariableNameBatteryDto[]> {
        let url_ = this.baseUrl + "/api/variables/all-dataset-variable-battery";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetDatasetVariableNameBattery(_response));
        });
    }

    protected processGetDatasetVariableNameBattery(response: Response): Promise<VariableNameBatteryDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariableNameBatteryDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableNameBatteryDto[]>(null as any);
    }

    getStems(projectId: number, versionId: string | null): Promise<VariableStemDto[]> {
        let url_ = this.baseUrl + "/api/variables/stems/{projectId}/{versionId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (versionId === undefined || versionId === null)
            throw new Error("The parameter 'versionId' must be defined.");
        url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStems(_response));
        });
    }

    protected processGetStems(response: Response): Promise<VariableStemDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as VariableStemDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<VariableStemDto[]>(null as any);
    }

    getAssigners(projectId: number, encodedVersionId: string | null, modificationId: number | null | undefined): Promise<AssignerHintsDto> {
        let url_ = this.baseUrl + "/api/variables/assigners/{projectId}/{encodedVersionId}?";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (modificationId !== undefined && modificationId !== null)
            url_ += "modificationId=" + encodeURIComponent("" + modificationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAssigners(_response));
        });
    }

    protected processGetAssigners(response: Response): Promise<AssignerHintsDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as AssignerHintsDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<AssignerHintsDto>(null as any);
    }

    getBrands(projectId: number, encodedVersionId: string | null, assigner: string | null): Promise<string[]> {
        let url_ = this.baseUrl + "/api/variables/brands/{projectId}/{encodedVersionId}/{assigner}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (assigner === undefined || assigner === null)
            throw new Error("The parameter 'assigner' must be defined.");
        url_ = url_.replace("{assigner}", encodeURIComponent("" + assigner));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetBrands(_response));
        });
    }

    protected processGetBrands(response: Response): Promise<string[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as string[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<string[]>(null as any);
    }

    recodeVariable(request: RecodeVariableCommand): Promise<RecodeDto> {
        let url_ = this.baseUrl + "/api/variables/recode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processRecodeVariable(_response));
        });
    }

    protected processRecodeVariable(response: Response): Promise<RecodeDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as RecodeDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<RecodeDto>(null as any);
    }

    editDisplayLabels(request: EditDisplayLabelsCommand): Promise<EditedVariablesDto> {
        let url_ = this.baseUrl + "/api/variables/edit-labels";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processEditDisplayLabels(_response));
        });
    }

    protected processEditDisplayLabels(response: Response): Promise<EditedVariablesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EditedVariablesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<EditedVariablesDto>(null as any);
    }

    resetVariableChanges(request: ResetVariableChangesCommand): Promise<void> {
        let url_ = this.baseUrl + "/api/variables/reset-changes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processResetVariableChanges(_response));
        });
    }

    protected processResetVariableChanges(response: Response): Promise<void> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            return;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<void>(null as any);
    }

    getStackables(projectId: number, encodedVersionId: string | null, assigner: string | null): Promise<StackablesDto> {
        let url_ = this.baseUrl + "/api/variables/stackables/{projectId}/{encodedVersionId}/{assigner}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (encodedVersionId === undefined || encodedVersionId === null)
            throw new Error("The parameter 'encodedVersionId' must be defined.");
        url_ = url_.replace("{encodedVersionId}", encodeURIComponent("" + encodedVersionId));
        if (assigner === undefined || assigner === null)
            throw new Error("The parameter 'assigner' must be defined.");
        url_ = url_.replace("{assigner}", encodeURIComponent("" + assigner));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetStackables(_response));
        });
    }

    protected processGetStackables(response: Response): Promise<StackablesDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as StackablesDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as any;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<StackablesDto>(null as any);
    }
}

export interface IWalrProjectsClient {

    createWalrProject(command: CreateWalrProjectCommand): Promise<WalrProjectDto>;
}

export class WalrProjectsClient extends BaseClient implements IWalrProjectsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createWalrProject(command: CreateWalrProjectCommand): Promise<WalrProjectDto> {
        let url_ = this.baseUrl + "/api/walrprojects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateWalrProject(_response));
        });
    }

    protected processCreateWalrProject(response: Response): Promise<WalrProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WalrProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WalrProjectDto>(null as any);
    }
}

export interface IWorkdayProjectClient {

    createWorkDayProject(command: CreateWorkdayProjectCommand): Promise<WorkdayProjectDto>;

    getAllWorkdayProjects(): Promise<WorkdayProjectDto[]>;

    updateWorkdayProjectStar(command: UpdateWorkdayProjectStarCommand): Promise<NoData>;

    getWorkdayProjectById(id: number): Promise<WorkdayProjectDto>;

    updateWorkdayProject(request: UpdateWorkdayProjectCommand): Promise<NoData>;
}

export class WorkdayProjectClient extends BaseClient implements IWorkdayProjectClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createWorkDayProject(command: CreateWorkdayProjectCommand): Promise<WorkdayProjectDto> {
        let url_ = this.baseUrl + "/api/workdayproject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateWorkDayProject(_response));
        });
    }

    protected processCreateWorkDayProject(response: Response): Promise<WorkdayProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkdayProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkdayProjectDto>(null as any);
    }

    getAllWorkdayProjects(): Promise<WorkdayProjectDto[]> {
        let url_ = this.baseUrl + "/api/workdayproject";
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetAllWorkdayProjects(_response));
        });
    }

    protected processGetAllWorkdayProjects(response: Response): Promise<WorkdayProjectDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkdayProjectDto[];
            return result200;
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkdayProjectDto[]>(null as any);
    }

    updateWorkdayProjectStar(command: UpdateWorkdayProjectStarCommand): Promise<NoData> {
        let url_ = this.baseUrl + "/api/workdayproject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateWorkdayProjectStar(_response));
        });
    }

    protected processUpdateWorkdayProjectStar(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    getWorkdayProjectById(id: number): Promise<WorkdayProjectDto> {
        let url_ = this.baseUrl + "/api/workdayproject/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetWorkdayProjectById(_response));
        });
    }

    protected processGetWorkdayProjectById(response: Response): Promise<WorkdayProjectDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkdayProjectDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkdayProjectDto>(null as any);
    }

    updateWorkdayProject(request: UpdateWorkdayProjectCommand): Promise<NoData> {
        let url_ = this.baseUrl + "/api/workdayproject/update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: RequestInit = {
            body: content_,
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateWorkdayProject(_response));
        });
    }

    protected processUpdateWorkdayProject(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }
}

export interface IWorkdayProjectDatasetsClient {

    createWorkdayProjectDataSet(command: CreateWorkdayProjectDatasetCommand): Promise<WorkdayProjectDatasetDto>;

    updateWorkdayDatasetStatus(command: UpdateWorkdayDatasetStatusCommand): Promise<NoData>;

    getByWorkdayProjectId(workdayProjectId: number): Promise<WorkdayDatasetDto[]>;
}

export class WorkdayProjectDatasetsClient extends BaseClient implements IWorkdayProjectDatasetsClient {
    private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        super();
        this.http = http ? http : window as any;
        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    createWorkdayProjectDataSet(command: CreateWorkdayProjectDatasetCommand): Promise<WorkdayProjectDatasetDto> {
        let url_ = this.baseUrl + "/api/workdayprojectdatasets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processCreateWorkdayProjectDataSet(_response));
        });
    }

    protected processCreateWorkdayProjectDataSet(response: Response): Promise<WorkdayProjectDatasetDto> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkdayProjectDatasetDto;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkdayProjectDatasetDto>(null as any);
    }

    updateWorkdayDatasetStatus(command: UpdateWorkdayDatasetStatusCommand): Promise<NoData> {
        let url_ = this.baseUrl + "/api/workdayprojectdatasets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(command);

        let options_: RequestInit = {
            body: content_,
            method: "PATCH",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processUpdateWorkdayDatasetStatus(_response));
        });
    }

    protected processUpdateWorkdayDatasetStatus(response: Response): Promise<NoData> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as NoData;
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<NoData>(null as any);
    }

    getByWorkdayProjectId(workdayProjectId: number): Promise<WorkdayDatasetDto[]> {
        let url_ = this.baseUrl + "/api/workdayprojectdatasets/{workdayProjectId}";
        if (workdayProjectId === undefined || workdayProjectId === null)
            throw new Error("The parameter 'workdayProjectId' must be defined.");
        url_ = url_.replace("{workdayProjectId}", encodeURIComponent("" + workdayProjectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_: RequestInit = {
            method: "GET",
            headers: {
                "Accept": "application/json"
            }
        };

        return this.http.fetch(url_, options_).then((_response: Response) => {
            return this.transformResult(url_, _response, (_response: Response) => this.processGetByWorkdayProjectId(_response));
        });
    }

    protected processGetByWorkdayProjectId(response: Response): Promise<WorkdayDatasetDto[]> {
        const status = response.status;
        let _headers: any = {}; if (response.headers && response.headers.forEach) { response.headers.forEach((v: any, k: any) => _headers[k] = v); };
        if (status === 200) {
            return response.text().then((_responseText) => {
            let result200: any = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as WorkdayDatasetDto[];
            return result200;
            });
        } else if (status === 400) {
            return response.text().then((_responseText) => {
            let result400: any = null;
            result400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            });
        } else if (status === 404) {
            return response.text().then((_responseText) => {
            let result404: any = null;
            result404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as ErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result404);
            });
        } else if (status === 500) {
            return response.text().then((_responseText) => {
            let result500: any = null;
            result500 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as BusinessException;
            return throwException("A server side error occurred.", status, _responseText, _headers, result500);
            });
        } else if (status === 527) {
            return response.text().then((_responseText) => {
            let result527: any = null;
            result527 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver) as EncodingApiErrorResponse;
            return throwException("A server side error occurred.", status, _responseText, _headers, result527);
            });
        } else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve<WorkdayDatasetDto[]>(null as any);
    }
}

export interface BatteryDto {
    id: number;
    modificationId?: number | undefined;
    originValue: string;
    newValue: string;
    oldVariableLabel?: string | undefined;
    variableLabel?: string | undefined;
    userId: number;
    createdAt: string;
    user?: UserDto | undefined;
    createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
    validationStatus?: InstructionValidationStatuses;
}

export interface UserDto {
    id?: number;
    firstName?: string | undefined;
    lastName?: string | undefined;
    userName?: string | undefined;
}

export interface CreateCustomEmailNotificationDto {
    title: string;
    body?: string | undefined;
    additionalProps?: { [key: string]: string; } | undefined;
    environment?: string | undefined;
}

export enum InstructionValidationStatuses {
    Success = "Success",
    Failed = "Failed",
    Warning = "Warning",
}

export interface ErrorResponse {
    errorMessage?: string | undefined;
    errors?: { [key: string]: string[]; } | undefined;
}

export interface Exception {
    Message?: string;
    InnerException?: Exception | undefined;
    Source?: string | undefined;
    StackTrace?: string | undefined;
}

export interface BusinessException extends Exception {
}

export interface EncodingApiErrorResponse extends ErrorResponse {
    request: string;
    response: string;
    url?: string | undefined;
}

export interface CreateBatteryCommand {
    variableLabel?: string | undefined;
    originValue: string;
    newValue: string;
    environment?: string | undefined;
    versionId: string;
    projectId: number;
    modificationId: number;
}

export interface UpdateBatteryCommand {
    id: number;
    variableLabel?: string | undefined;
    originValue: string;
    newValue: string;
    environment?: string | undefined;
    projectId: number;
    modificationId: number;
    versionId: string;
}

export interface CustomDataProjectDto {
    id?: number;
    workdayId?: string | undefined;
    name?: string | undefined;
    originProjectId?: string | undefined;
}

export interface CreateCustomDataProjectCommand {
    projectName: string;
    workdayId?: string | undefined;
    workdayProjectId?: number | undefined;
}

export interface UploadCustomDataPresignedUrlDto {
    projectId?: string | undefined;
    projectName?: string | undefined;
    dataPresignedUrl?: string | undefined;
    dictionaryPresignedUrl?: string | undefined;
    token?: string | undefined;
}

export interface CreateCustomDataUploadPollingCommand {
    projectId: number;
    token: string;
}

export interface CustomDataUploadPollingDto {
    id?: number;
    projectId?: number;
    originalProjectId?: string | undefined;
    projectName?: string | undefined;
    token?: string | undefined;
    status?: CustomDataUploadStatuses;
    message?: string | undefined;
    errorMessage?: string | undefined;
}

export enum CustomDataUploadStatuses {
    ReadyForUpload = "ReadyForUpload",
    Success = "Success",
    Failed = "Failed",
    InProgress = "InProgress",
}

export interface CustomDataUploadPollingStatusDto {
    status?: CustomDataUploadStatuses;
    message?: string | undefined;
}

export interface PaginatedDtoOfVariableDto {
    pageData?: VariableDto[] | undefined;
    totalCount?: number;
    totalCountWithoutFilter?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export interface VariableDto {
    oldName: string;
    name: string;
    recodeName?: string | undefined;
    label: string;
    oldLabel: string;
    oldDisplayLabel?: string | undefined;
    displayLabel?: string | undefined;
    oldDisplayLabelLevel2?: string | undefined;
    displayLabelLevel2?: string | undefined;
    valueLabel?: string | undefined;
    variableCategories?: VariableCategoryDto[] | undefined;
    batteryId?: number | undefined;
    batteryOriginValue: string;
    battery: string;
    isRespondable?: boolean;
    isRecodeAvailable?: boolean;
    variableType?: VariableTypes;
    modifiedAt?: string | undefined;
    variableTags?: VariableTags[] | undefined;
    quantileSplitCount?: number | undefined;
    isExcluded?: boolean;
    recodeNotes?: string[] | undefined;
    editNotes?: string[] | undefined;
    variableFullName?: string | undefined;
    dataType?: DataTypes;
}

export interface VariableCategoryDto {
    id: string;
    oldOrderIndex: number;
    orderIndex: number;
    oldValue: string;
    value: string;
    isExcluded?: boolean;
    childItems?: VariableCategoryChildDto[] | undefined;
}

export interface VariableCategoryChildDto {
    id: string;
    oldOrderIndex: number;
    orderIndex: number;
    oldValue: string;
    value: string;
}

export enum VariableTypes {
    Categorical = "Categorical",
    Scalar = "Scalar",
    Binary = "Binary",
}

export enum VariableTags {
    SyncPending = "SyncPending",
    SyncComplete = "SyncComplete",
    Edited = "Edited",
    Recoded = "Recoded",
    Filtered = "Filtered",
    Excluded = "Excluded",
    Cleaned = "Cleaned",
}

export enum DataTypes {
    Categorical = "Categorical",
    Numeric = "Numeric",
    Date = "Date",
    Text = "Text",
}

export interface PaginatedQuery {
    pageNumber?: number;
    pageSize?: number;
}

export interface PageQueryOfVariableDto extends PaginatedQuery {
}

export interface GetDatasetPageDictionariesQuery extends PageQueryOfVariableDto {
    context: PageContextOfProjectDataFilter;
    projectId?: number;
    encodedVersionId?: string | undefined;
    stackId?: number | undefined;
    modificationId?: number | undefined;
    searchPageKey?: string | undefined;
    isDV?: boolean;
    isRespondables?: boolean;
}

export interface PageContextOfProjectDataFilter {
    page?: PaginatedQuery | undefined;
    filter?: ProjectDataFilter | undefined;
    sortList?: SorterDescriptor[] | undefined;
}

export interface BaseFilter {
}

export interface ProjectDataFilter extends BaseFilter {
    batteries?: string[] | undefined;
    variableTags?: VariableTags[] | undefined;
    tableFilters?: TableFilter[] | undefined;
}

export interface TableFilter {
    key?: string | undefined;
    values?: string[] | undefined;
}

export interface SorterDescriptor {
    field?: string | undefined;
    directions?: SortDirections;
}

export enum SortDirections {
    None = "None",
    Asceding = "Asceding",
    Desceding = "Desceding",
}

export interface GetExcludeDatasetPageDictionariesQuery extends PageQueryOfVariableDto {
    context: PageContextOfProjectDataFilter;
    projectId?: number;
    encodedVersionId?: string | undefined;
    stackId?: number | undefined;
    modificationId?: number | undefined;
    searchPageKey?: string | undefined;
    isDV?: boolean;
    isRespondables?: boolean;
}

export interface UpdateProjectSettingsCommand {
    checkedBatteries?: string | undefined;
    projectId: number;
    encodedVersionId: string;
    prevEncodedVersionId: string;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    isStacked?: boolean;
    batteryFilterTypes?: BatteryFilterType[] | undefined;
    excludedVariables?: string | undefined;
}

export enum BatteryFilterType {
    DV = "DV",
    Respondables = "Respondables",
}

export interface AddOrUpdateExcludedProjectSettingsCommand {
    checkedBatteries?: string | undefined;
    projectId: number;
    encodedVersionId: string;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    batteryFilterTypes?: BatteryFilterType[] | undefined;
    excludedVariables?: string | undefined;
}

export interface RemoveExcludedProjectSettingsCommand {
    checkedBatteries?: string | undefined;
    projectId: number;
    encodedVersionId: string;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    batteryFilterTypes?: BatteryFilterType[] | undefined;
    excludedVariables?: string | undefined;
}

export interface ProjectSettingsDto {
    checkedBatteries?: string | undefined;
    projectId?: number;
    encodedVersionId?: string | undefined;
    batteryFilterTypes?: BatteryFilterType[] | undefined;
    excludedVariables?: string | undefined;
    isStacked?: boolean;
}

export interface VariablesFilterOptionsDto {
    key?: string | undefined;
    options?: string[] | undefined;
}

export interface GetIncludeVariablesFilterOptionsQuery {
    projectId?: number;
    encodedVersionId?: string | undefined;
    field?: string | undefined;
    searchText?: string | undefined;
    isDV?: boolean;
    isRespondables?: boolean;
    searchPageKey?: string | undefined;
    stackId?: number | undefined;
    modificationId?: number | undefined;
}

export interface GetExcludeVariablesFilterOptionsQuery {
    projectId?: number;
    encodedVersionId?: string | undefined;
    field?: string | undefined;
    searchText?: string | undefined;
    isDV?: boolean;
    isRespondables?: boolean;
    searchPageKey?: string | undefined;
    stackId?: number | undefined;
    modificationId?: number | undefined;
}

export interface DatasetlistDto {
    datasetId?: string | undefined;
    source?: string | undefined;
    datasetName?: string | undefined;
    encodings?: string[] | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export interface NoData {
}

export interface ExcludedVariableDto {
    id?: number;
    modificationId?: number;
    variableFriendlyName?: string | undefined;
    createdAt?: string;
    createdById?: number;
    createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
    validationStatus?: InstructionValidationStatuses;
}

export interface CreateExcludedVariableCommand {
    variableFriendlyName: string;
    environment?: string | undefined;
    modificationId: number;
    projectId: number;
    versionId: string;
}

export interface DeleteExcludedVariableCommand {
    variableFriendlyName: string;
    environment?: string | undefined;
    modificationId: number;
    projectId: number;
    versionId: string;
}

export interface ForstaProjectDto {
    id: number;
    forstaProjectId: string;
    projectId: number;
    encodingVersionId: string;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    token: string;
    transformationId?: string | undefined;
    createdById: number;
    createdAt: string;
    modifiedAt: string;
    status: ForstaProjectStatuses;
    variableName?: string | undefined;
    weightVariable?: string | undefined;
    batchValues?: string[] | undefined;
    activate?: boolean;
    delete?: boolean;
    fromIntegration?: boolean;
}

export enum ForstaProjectStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Completed = "Completed",
    Old = "Completed",
}

export interface CreateForstaProjectCommand {
    forstaProjectId: string;
    projectId: number;
    encodingVersionId: string;
    variableName?: string | undefined;
    weightVariable?: string | undefined;
    batchValues?: BatchValueDto[] | undefined;
    batteries: string[];
    activate?: boolean;
    delete?: boolean;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    fromIntegration?: boolean;
}

export interface BatchValueDto {
    value: string;
    index: number;
}

export interface CreateForstaProjectByDatasetCommand {
    forstaProjectId: string;
    projectId: number;
    encodingVersionId: string;
    variableName?: string | undefined;
    weightVariable?: string | undefined;
    batchValues?: BatchValueDto[] | undefined;
    activate?: boolean;
    delete?: boolean;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    fromIntegration?: boolean;
}

export interface ForstaProjectStatusDto {
    status: ForstaProjectStatuses;
    transform?: ForstaProjectStatuses | undefined;
    export?: ForstaProjectStatuses | undefined;
    activation?: ForstaProjectStatuses | undefined;
    deletion?: ForstaProjectStatuses | undefined;
    message?: string | undefined;
    fromIntegration?: boolean;
}

export interface CreateInteractionLogCommand {
    operationType: InteractionOperations;
    operationMenu: InteractionOperationMenus;
    referenceID: string;
}

export enum InteractionOperations {
    Open = "Open",
}

export enum InteractionOperationMenus {
    Project = "Project",
    DataSet = "DataSet",
}

export interface DeleteInteractionLogsCommand {
    userName: string;
}

export interface RecentInteractionsLogDto {
    projectInteractions?: ProjectInteractionLogDto[] | undefined;
    dataSetInteractions?: DatasetIntegrationLogDto[] | undefined;
}

export interface ProjectInteractionLogDto {
    projectId: number;
    name: string;
    workDayProjectId: string;
    isStarred: boolean;
    interactionDate: string;
}

export interface DatasetIntegrationLogDto {
    datasetId: number;
    name: string;
    originProjectId: string;
    interactionDate: string;
}

export interface ModificationFilterDto {
    id: number;
    modificationId: number;
    variableFriendlyName: string;
    type: ModificationFilterType;
    definitions: ModificationFilterDefinition[];
    createdAt: string;
    modifiedAt: string;
    createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
    validationStatus?: InstructionValidationStatuses;
}

export enum ModificationFilterType {
    Categorical = "Categorical",
    Numeric = "Numeric",
    Date = "Date",
}

export interface ModificationFilterDefinition {
    operator: ModificationFilterOperator;
    values: string[];
}

export enum ModificationFilterOperator {
    Gt = "Gt",
    Gte = "Gte",
    Lt = "Lt",
    Lte = "Lte",
    Eq = "Eq",
    Ne = "Ne",
    Between = "Between",
}

export interface CreateModificationFiltersCommand {
    variableFriendlyName: string;
    type: ModificationFilterType;
    definitions: ModificationFilterDefinition[];
    environment?: string | undefined;
    modificationId: number;
    projectId?: number;
    versionId?: string | undefined;
}

export interface UpdateModificationFilterCommand {
    id: number;
    definitions: ModificationFilterDefinition[];
    environment?: string | undefined;
    modificationId: number;
    projectId: number;
    versionId?: string | undefined;
}

export interface DeletionFilterDto {
    id: number;
    createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
    validationStatus?: InstructionValidationStatuses;
}

export interface DeleteModificationFilterCommand {
    id: number;
    environment?: string | undefined;
    modificationId: number;
    projectId: number;
    versionId: string;
}

export interface ModificationDto {
    id: number;
    name: string;
    projectId: number;
    encodedVersionId: string;
    dateCreated: string;
    dateModified: string;
    deleted: boolean;
    syncedDate?: string | undefined;
    syncedBy?: UserDto | undefined;
}

export interface CreateModificationCommand {
    name: string;
    projectId: number;
    encodedVersionId: string;
}

export interface RenameModificationCommand {
    id: number;
    name: string;
}

export interface RespondentDateModel {
    content?: { [key: string]: string; } | undefined;
}

export interface ImportInstructionDto {
    instruction?: InstructionDto | undefined;
    validationResult?: InstructionValidationResultDto | undefined;
}

export interface InstructionDto {
    modificationId?: number;
    filterRespondents?: RespondentsFilterDto[] | undefined;
    renamedBatteries?: BatteryRenameDto[] | undefined;
    recodeVariables?: VariableRecodeDto[] | undefined;
    relabelVariables?: VariableRelabelDto[] | undefined;
    hiddenValues?: VariableHiddenDto[] | undefined;
}

export interface RespondentsFilterDto {
    filterType?: ModificationFilterType;
    variableFriendlyName: string;
    values: any[];
    operator: ModificationFilterOperator;
    isIncompatible?: boolean;
}

export interface BatteryRenameDto {
    originValue: string;
    newValue: string;
    isIncompatible?: boolean;
}

export interface VariableRecodeDto {
    variableFullName: string;
    valueLabel: string;
    isQuantile: boolean;
    existingCode: number;
    newCode: number;
    isIncompatible?: boolean;
}

export interface VariableRelabelDto {
    variableFriendlyName: string;
    oldLabel: string;
    newLabel: string;
    isIncompatible?: boolean;
}

export interface VariableHiddenDto {
    variableFullName: string;
    valueLabel: string;
    isIncompatible?: boolean;
}

export interface InstructionValidationResultDto {
    status?: InstructionValidationStatuses;
    failures?: InstructionFailureItemDto[] | undefined;
}

export interface InstructionFailureItemDto {
    type?: string | undefined;
    message?: string | undefined;
}

export interface EncodingFileDto {
    token?: string | undefined;
    url?: string | undefined;
}

export interface BaseDownloadRequest {
    zerofill?: boolean;
    projectId: number;
    encodingVersionId: string;
    includeEmptyVariables?: boolean;
    concatenateHeaders?: boolean;
    filters?: string | undefined;
}

export interface CreateSpssFileByModificationIdCommand extends BaseDownloadRequest {
    batteries: string[];
    modificationId: number;
    archived: boolean;
}

export interface CreateCsvFileByModificationIdCommand extends BaseDownloadRequest {
    batteries: string[];
    modificationId: number;
}

export interface CreateDatasetCsvFileByModificationIdCommand extends BaseDownloadRequest {
    modificationId: number;
}

export interface CreateDatasetSpssFileByModificationIdCommand extends BaseDownloadRequest {
    modificationId: number;
    archived: boolean;
}

export interface ModificationStackDto {
    id: number;
    projectId: number;
    encodingVersionId: string;
    modificationId?: number | undefined;
    name: string;
    displayName: string;
    jobId: string;
    statusId: ModificationStackStatuses;
    token?: string | undefined;
    createdAt: string;
    modifiedAt: string;
    createdByUserId?: number | undefined;
    modifiedByUserId?: number | undefined;
}

export enum ModificationStackStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Success = "Success",
    Unknown = "Unknown",
}

export interface ModificationStackSpecDto {
    assigner: AssignerDto;
    stackableBatteries: StackableBatteryDto[];
    stackableVariables: StackableVariableDto[];
}

export interface AssignerDto {
    name: string;
    brands: string[];
}

export interface StackableBatteryDto {
    stem: string;
    role: StackBatteryRoles;
    exclude?: string[] | undefined;
}

export enum StackBatteryRoles {
    Other = "Other",
    Dependent = "Dependent",
    Independent = "Independent",
}

export interface StackableVariableDto {
    name: string;
    stem?: string | undefined;
    friendlyName?: string | undefined;
    valueLabels: string[];
    role?: StackVariableRoles;
}

export enum StackVariableRoles {
    Subgroup = "Subgroup",
    Filter = "Filter",
    Other = "Other",
}

export interface CreateModificationStackCommand {
    projectId: number;
    versionId: string;
    modificationId?: number | undefined;
    name: string;
    token: string;
}

export interface PublishedStackDto {
    token: string;
}

export interface PublishModificationStackCommand {
    projectId: number;
    versionId: string;
    modificationId?: number | undefined;
    name: string;
    spec: ModificationStackSpecDto;
}

export interface StackValidationStatusDto {
    status?: ModificationStackValidationStatuses;
    errors?: string | undefined;
    failures?: string[] | undefined;
}

export enum ModificationStackValidationStatuses {
    Error = "Error",
    Success = "Success",
}

export interface ValidateModificationStackCommand {
    projectId: number;
    versionId: string;
    modificationId?: number | undefined;
    name: string;
    spec: ModificationStackSpecDto;
}

export interface UpdateModificationStackCommand {
    id: number;
    displayName: string;
}

export interface StackStatusDto {
    status?: ModificationStackStatuses;
    errors?: string | undefined;
}

export interface CreateSpssFileByStackIdCommand extends BaseDownloadRequest {
    archived: boolean;
    stackId: number;
    batteries: string[];
}

export interface CreateCsvFileByStackIdCommand extends BaseDownloadRequest {
    stackId: number;
    batteries: string[];
}

export interface CreateDatasetCsvFileByStackIdCommand extends BaseDownloadRequest {
    stackId: number;
}

export interface CreateDatasetSpssFileByStackIdCommand extends BaseDownloadRequest {
    archived: boolean;
    stackId: number;
}

export interface OpenEndCodedVariableDto {
    id: number;
    variableFullName: string;
    variableLabel?: string | undefined;
    wave?: string | undefined;
    token?: string | undefined;
    status?: string | undefined;
    totalCount?: number | undefined;
    codedCount?: number | undefined;
    codingEngine?: string | undefined;
    createdAt?: string;
    normalizedCreatedDate?: string | undefined;
}

export interface CreateOECodingVariableCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    variableFullName?: string | undefined;
}

export interface OriginProjectDto {
    name?: string | undefined;
    label?: string | undefined;
    environmentKey?: string | undefined;
    source?: string | undefined;
    sourceCode?: string | undefined;
}

export interface PowerBIFileDto {
    questionsUrl?: string | undefined;
    answersUrl?: string | undefined;
    demographicsUrl?: string | undefined;
    openEndsUrl?: string | undefined;
}

export interface ExportPowerBIProjectCommand {
    projectId: number;
    encodingVersionId: string;
    demographicVariables: string[];
    assignerVariables: string[];
    batteries: string[];
    modificationId?: number | undefined;
    stackId?: number | undefined;
}

export interface ProjectIntegrationDto {
    id?: number;
    source?: string | undefined;
    integrationType?: IntegrationType;
    normalizedIntegrationType?: string | undefined;
    integrationDirection?: IntegrationDirection;
    externalProjectId?: string | undefined;
    externalDatasetId?: string | undefined;
    projectBaseSize?: number | undefined;
    platformBaseSize?: number | undefined;
    dataFormat?: DataFormat;
    normalizedDataFormat?: string | undefined;
    encodedVersionId?: string | undefined;
    createdAt?: string;
    normalizedCreatedDate?: string | undefined;
    modifiedAt?: string | undefined;
    normalizedModifiedDate?: string | undefined;
    createdBy?: string | undefined;
    modifiedBy?: string | undefined;
    currentIntegrationStatus?: ProjectIntegrationHistoryStatus | undefined;
    currentIntegrationToken?: string | undefined;
}

export enum IntegrationType {
    Forsta = "Forsta",
    Walr = "Walr",
    PowerBI = "PowerBI",
    Tableau = "Tableau",
    Ascribe = "Ascribe",
    ForstaVisualizations = "ForstaVisualizations",
}

export enum IntegrationDirection {
    None = "None",
    In = "In",
    Out = "Out",
    InOut = "InOut",
}

export enum DataFormat {
    None = "None",
    Stacked = "Stacked",
    Flat = "Flat",
    BIFormat = "BIFormat",
}

export enum ProjectIntegrationHistoryStatus {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Success = "Success",
    Unknown = "Unknown",
}

export interface CreatePowerBIIntegrationCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    externalProjectId?: string | undefined;
    modificationOrStackId?: number | undefined;
    projectDataSet?: ProjectDataSet;
    assignerVariable?: string[] | undefined;
    demographicVariables?: string[] | undefined;
}

export enum ProjectDataSet {
    Original = "Original",
    Modification = "Modification",
    Stack = "Stack",
}

export interface CreateForstaIntegrationCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    externalProjectId?: string | undefined;
    modificationOrStackId?: number | undefined;
    projectDataSet?: ProjectDataSet;
    variableName?: string | undefined;
    weightVariable?: string | undefined;
    batchValues?: BatchValueDto[] | undefined;
    activate?: boolean;
    delete?: boolean;
}

export interface PushForstaVisualizationIntegrationCommand {
    integrationId: number;
    forstaProjectId?: string | undefined;
    isEncoded?: string | undefined;
}

export interface UpdateForstaVisulizationStatusCommand {
    forstaProjectId?: string | undefined;
    integrationId?: number;
}

export interface CreateAscribeIntegrationCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    externalProjectId?: string | undefined;
    modificationOrStackId?: number | undefined;
    projectDataSet?: ProjectDataSet;
    ascribeProjectId?: string | undefined;
}

export interface DownloadPowerBICommand {
    integrationId: number;
    batteries: string[];
}

export interface CreateWalrIntegrationResponseDto {
    integrationId: number;
    message?: string | undefined;
    walrDatasetId?: string | undefined;
}

export interface CreateWalrIntegrationCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    walrProjectId?: string | undefined;
    modificationOrStackId?: number | undefined;
    dataFormat?: DataFormat;
    projectDataSet?: ProjectDataSet;
    walrDatasetName?: string | undefined;
    walrDatasetId?: string | undefined;
}

export interface WalrExportMetadataResponseDto {
    metadataId: string;
    errorMessage?: string | undefined;
}

export interface WalrExportMetadataCommand {
    integrationId?: number;
}

export interface WalrExportDataResponseDto {
    walrProjectId: string;
    token: string;
    message?: string | undefined;
}

export interface WalrExportDataCommand {
    integrationId: number;
}

export interface WalrExportStatusResponseDto {
    status: ProjectIntegrationHistoryStatus;
    message?: string | undefined;
}

export interface ProjectDto {
    id?: number;
    name?: string | undefined;
    dataSource?: ProjectSourceDto | undefined;
    originProjectId?: string | undefined;
    dimensionEnvironmentKey?: string | undefined;
    normalizedModifiedAt?: string | undefined;
    normalizedVersionDate?: string | undefined;
    normalizedDataSource?: string | undefined;
    versionId?: string | undefined;
    versionDate?: string | undefined;
    createdAt?: string;
    modifiedAt?: string | undefined;
    sourceCode?: string | undefined;
    resultSourceName?: string | undefined;
    workdayId?: string | undefined;
    status?: WorkdayProjectDatasetStatus;
}

export interface ProjectSourceDto {
    id: number;
    name: string;
    displayName: string;
    iconTag: string;
    displayOrder: number;
}

export enum WorkdayProjectDatasetStatus {
    Active = "Active",
    Archived = "Archived",
}

export interface MergedProjectDto {
    id?: number | undefined;
    originProjectId?: string | undefined;
    name?: string | undefined;
    upperName?: string | undefined;
    originSource?: string | undefined;
    normalizedDataSource?: string | undefined;
    createdAt?: string;
    modifiedAt?: string;
    versionDate?: string;
    dimensionEnvironmentKey?: string | undefined;
    versionId?: string | undefined;
    normalizedModifiedAt?: string | undefined;
    normalizedVersionDate?: string | undefined;
    iconTag?: string | undefined;
    workdayId?: string | undefined;
}

export interface ShortProjectDto {
    id?: number | undefined;
    originProjectId: string;
    name: string;
    originSource: string;
}

export interface EntityIdDtoOfInteger {
    id: number;
}

export interface CreateProjectCommand {
    originProjectId: string;
    originProjectName?: string | undefined;
    environmentKey?: string | undefined;
    sourceId: number;
    sourceCode?: string | undefined;
}

export interface CreateProjectFromEncodedCommand {
    originProjectId: string;
}

export interface PaginatedDtoOfMergedProjectDto {
    pageData?: MergedProjectDto[] | undefined;
    totalCount?: number;
    totalCountWithoutFilter?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export interface PageContextOfProjectFilter {
    page?: PaginatedQuery | undefined;
    filter?: ProjectFilter | undefined;
    sortList?: SorterDescriptor[] | undefined;
}

export interface ProjectFilter extends BaseFilter {
    searchString?: string | undefined;
    originProjectId?: FilterDescriptorOfString | undefined;
    dataSource?: FilterDescriptorOfString | undefined;
    name?: FilterDescriptorOfString | undefined;
    versionDate?: FilterDescriptorOfDateTimeOffset | undefined;
    modifiedAt?: FilterDescriptorOfDateTimeOffset | undefined;
    workdayId?: FilterDescriptorOfString | undefined;
}

export interface FilterDescriptorOfString {
    value?: string | undefined;
    values?: string[] | undefined;
    range?: FilterRangeOfString | undefined;
}

export interface FilterRangeOfString {
    lte?: string | undefined;
    gte?: string | undefined;
    gt?: string | undefined;
    lt?: string | undefined;
}

export interface FilterDescriptorOfDateTimeOffset {
    value?: string;
    values?: string[] | undefined;
    range?: FilterRangeOfDateTimeOffset | undefined;
}

export interface FilterRangeOfDateTimeOffset {
    lte?: string;
    gte?: string;
    gt?: string;
    lt?: string;
}

export interface UpdateProjectCommand {
    projectId?: number;
    name?: string | undefined;
    encodedVersionId?: string | undefined;
    isTriggeredEncoding?: boolean;
    encodedVersionDate?: string | undefined;
}

export interface ProjectVersionDto {
    id: number;
    projectId: number;
    encodedVersionId: string;
    analysable: boolean;
}

export interface CreateOrUpdateProjectVersionCommand {
    projectId: number;
    encodedVersionId: string;
    analysable: boolean;
}

export interface PaginatedDtoOfVariablesBatteryDto {
    pageData?: VariablesBatteryDto[] | undefined;
    totalCount?: number;
    totalCountWithoutFilter?: number | undefined;
    pageNumber?: number;
    pageSize?: number;
}

export interface VariablesBatteryDto {
    battery?: string | undefined;
    variables?: VariableDto[] | undefined;
}

export interface GetDataDictionariesPageQuery {
    context: PageContextOfProjectDataFilter;
    projectId?: number;
    encodedVersionId?: string | undefined;
    stackId?: number | undefined;
    modificationId?: number | undefined;
}

export interface OriginBatteryDto {
    name: string;
    label?: string | undefined;
    variableName?: string | undefined;
    isRespondable?: boolean;
    variableLabel?: string | undefined;
}

export interface CreateSpssFileByProjectIdCommand extends BaseDownloadRequest {
    archived: boolean;
    batteries: string[];
}

export interface CreateDatasetSpssFileByProjectIdCommand extends BaseDownloadRequest {
    archived: boolean;
}

export interface CreateCsvFileByProjectIdCommand extends BaseDownloadRequest {
    batteries: string[];
}

export interface CreateDatasetCsvFileByProjectIdCommand extends BaseDownloadRequest {
}

export interface GetVariablesFilterOptionsQuery {
    projectId?: number;
    encodedVersionId?: string | undefined;
    field?: string | undefined;
    batteries?: string[] | undefined;
    searchText?: string | undefined;
    stackId?: number | undefined;
    modificationId?: number | undefined;
}

export interface CompositeProjectMetadataDto {
    projectName?: string | undefined;
    projectReferences?: CompositeProjectReferenceDto[] | undefined;
}

export interface CompositeProjectReferenceDto {
    projectId?: string | undefined;
    version?: string | undefined;
    name?: string | undefined;
    id?: number | undefined;
    referenceType?: CompositeProjectReferenceType;
    headersDropped?: string[] | undefined;
    headersNotAvailable?: string[] | undefined;
    remappedVariables?: string[] | undefined;
}

export enum CompositeProjectReferenceType {
    Reference = "Reference",
    Merged = "Merged",
}

export interface UpdateCompositeMetadataCommand {
    projectId: number;
    version: string;
    projectName: string;
}

export interface CompositeMergeResponseDto {
    projectId?: number | undefined;
    originProjectId?: string | undefined;
    token?: string | undefined;
    message?: string | undefined;
    error?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export interface CompositeMergeProjectCommand {
    projectName?: string | undefined;
    baseProjectId?: string | undefined;
    appendedProjectIds?: string[] | undefined;
    workdayProjectId?: number | undefined;
}

export interface CompositeMergeStatusDto {
    status?: string | undefined;
    step?: string | undefined;
    message?: string | undefined;
    additionalProperties?: { [key: string]: any; } | undefined;
}

export interface EncodedDataDownloadStatusDto {
    status?: PollingStatuses;
    message?: string | undefined;
}

export enum PollingStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Unknown = "Unknown",
}

export interface DataCollectionVariableModel {
    dataType?: DataCollectionVariablesDataTypes;
    fullName?: string | undefined;
    variableName?: string | undefined;
    shortName?: string | undefined;
    batteryShortName?: string | undefined;
    label?: string | undefined;
    isRespondable?: boolean;
}

export enum DataCollectionVariablesDataTypes {
    None = "None",
    Long = "Long",
    Text = "Text",
    Categorical = "Categorical",
    Date = "Date",
    Boolean = "Boolean",
    Double = "Double",
}

export interface RelabeledVariableDto {
    message?: string | undefined;
    error?: string | undefined;
}

export interface EditVariableLabelCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    variableFriendlyName?: string | undefined;
    variableFullName?: string | undefined;
    oldVariableLabel?: string | undefined;
    variableLabel?: string | undefined;
    isTextVariable?: boolean;
}

export interface CreateSimilarityReportCommand {
    id: number;
    modificationId?: number | undefined;
    encodingVersionId: string;
    variable?: string | undefined;
    categories?: number[] | undefined;
    batteries: string[];
    zScore: number;
    abnormalitySelectivity?: number;
    runType: SimilarityReportRunType;
    timeAnalysis?: boolean;
}

export enum SimilarityReportRunType {
    Quick = "Quick",
    MaxPerformance = "MaxPerformance",
}

export interface CreateSimilarityReportIncludedVariableCommand {
    id: number;
    modificationId?: number | undefined;
    encodingVersionId: string;
    variable?: string | undefined;
    categories?: number[] | undefined;
    zScore: number;
    abnormalitySelectivity?: number;
    runType: SimilarityReportRunType;
    timeAnalysis?: boolean;
}

export interface SimilarityReportDto {
    urls: ReportUrlDto[];
}

export interface ReportUrlDto {
    name: string;
    url: string;
}

export interface DownloadSimilarityReportCommand {
    id: number;
    modificationId?: number | undefined;
    encodingVersionId: string;
    variable?: string | undefined;
    categories?: number[] | undefined;
    zScore: number;
    abnormalitySelectivity?: number;
    runType: SimilarityReportRunType;
}

export interface SimilarityReportStatusDto {
    message: string;
    status: SimilarityReportStatuses;
    subgroups: SubgroupDto[];
    readingParametersStatus: SimilarityReportStatuses;
    validatingParametersStatus: SimilarityReportStatuses;
}

export enum SimilarityReportStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Unknown = "Unknown",
}

export interface SubgroupDto {
    name: string;
    cleaningAndOrganizing: SimilarityReportStatuses;
    calculating: SimilarityReportStatuses;
    clustering: SimilarityReportStatuses;
    generatingExcel: SimilarityReportStatuses;
}

export interface SimilarityReportHistoryDto {
    token: string;
    status: SimilarityReportStatuses;
    createdAt: string;
    finishedAt?: string;
    errorMessage?: string | undefined;
    projectId?: number;
    modificationId?: number | undefined;
    encodingVersionId?: string | undefined;
    similarityReportMode?: SimilarityReportMode;
    similarityReportFormData?: SimilarityReportFormData | undefined;
}

export enum SimilarityReportMode {
    OpenEnds = "OpenEnds",
    Legacy = "Legacy",
}

export interface SimilarityReportFormData {
    variable?: string | undefined;
    categories?: number[] | undefined;
    batteries?: string[] | undefined;
    zScore?: number;
    abnormalitySelectivity?: number;
    runType?: SimilarityReportRunType;
    openEndVariables?: string[] | undefined;
    weights?: { [key in keyof typeof DataTypes]?: number; } | undefined;
    filters?: string | undefined;
}

export interface UpdateSimilarityReportHistoryCommand {
    token: string;
    status: SimilarityReportStatuses;
    errorMessage?: string | undefined;
}

/** Represents a void type, since Void is not a valid return type in C#. */
export interface Unit {
}

export interface SaveSimilarityConfigCommand {
    projectId: number;
    encodingVersionId: string;
    similarityConfigsName: string;
    variable?: string | undefined;
    categories?: number[] | undefined;
    timeAnalysis?: boolean;
    openEndVariables?: string[] | undefined;
    weights?: { [key in keyof typeof DataTypes]?: number; } | undefined;
    filters?: string | undefined;
}

export interface SimilarityFormConfigurationsDto {
    variable?: string | undefined;
    categories?: number[] | undefined;
    timestampAnalysis?: boolean;
    openEndVariables?: string[] | undefined;
    weights?: { [key in keyof typeof DataTypes]?: number; } | undefined;
    filters?: string | undefined;
}

export interface CreateSimilarityReportOpenEndsCommand {
    id: number;
    encodingVersionId: string;
    variable?: string | undefined;
    categories?: number[] | undefined;
    timeAnalysis?: boolean;
    openEndVariables?: string[] | undefined;
    weights: { [key in keyof typeof DataTypes]?: number; };
    filters?: string | undefined;
}

export interface DownloadSimilarityReportOpenEndsCommand {
    id: number;
    encodingVersionId: string;
    token: string;
}

export interface TextProjectSettingDto {
    id: number;
    projectId: number;
    languageVariableName: string;
}

export interface CreateOrUpdateTextProjectSettingCommand {
    languageVariableName: string;
    projectId: number;
}

export interface TextVariableDto {
    variableFullName?: string | undefined;
    variableLabel?: string | undefined;
    isRespondable?: boolean;
    battery?: string | undefined;
    nonEmptyCount?: number;
    nonEmptyCountPercentage?: number;
    translatedCount?: number;
    variableName?: string | undefined;
    isEdited?: boolean;
    datatype?: DataTypes;
}

export interface ExportResponseDto {
    token?: string | undefined;
    url?: string | undefined;
    message?: string | undefined;
    error?: string | undefined;
}

export interface DownloadTextVariablesCsvCommand {
    projectId: number;
    version?: string | undefined;
    filters?: string | undefined;
}

export interface InitiateTranslateJobDto {
    message: string;
    token?: string | undefined;
}

export interface InitiateTranslationCommand {
    projectId: number;
    languageVariableName?: string | undefined;
    variableName: string;
}

export interface DownloadTranslationDto {
    message?: string | undefined;
    token?: string | undefined;
}

export interface InitiateRelevancyCheckerDto {
    message: string;
    variableName?: string | undefined;
    token?: string | undefined;
}

export interface InitiateRelevancyCheckerCommand {
    projectId: number;
    englishOnly: boolean;
    variableName: string;
}

export interface DownloadRelevancyCheckerDto {
    message?: string | undefined;
    token?: string | undefined;
}

export interface DownloadRelevancyCheckerQuery {
    projectId: number;
    version?: string | undefined;
    englishOnly?: boolean;
    filters?: string | undefined;
}

export interface DownloadRelevancyReportDto {
    message?: string | undefined;
    presignedUrl?: string | undefined;
}

export interface TextDataDownloadStatusDto {
    status?: PollingStatuses;
    message?: string | undefined;
}

export interface RelevancyCheckerInitiateStatusDto {
    status?: RelevancyCheckerStatuses;
}

export enum RelevancyCheckerStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Completed = "Completed",
    Unknown = "Unknown",
}

export interface RelevancyCheckerDownloadStatusDto {
    status?: PollingStatuses;
    message?: string | undefined;
    presignedUrl?: string | undefined;
}

export interface TranslationDownloadStatusDto {
    status?: PollingStatuses;
    message?: string | undefined;
    presignedUrl?: string | undefined;
}

export interface TranslateInitiateStatusDto {
    status?: TranslateInitiateStatuses;
    message?: string | undefined;
}

export enum TranslateInitiateStatuses {
    InProgress = "InProgress",
    Failed = "Failed",
    Completed = "Completed",
    Unknown = "Unknown",
}

export interface CreateUnslotDto {
    token?: string | undefined;
    message?: string | undefined;
    error?: string | undefined;
}

export interface CreateUnslotSpecCommand {
    projectId?: number;
    encodedVersionId?: string | undefined;
    unslotSpecName?: string | undefined;
    numOfSlotVariables?: number;
    slotVariables?: string[] | undefined;
    brands?: string[] | undefined;
    variablesToUnslot?: VariableToUnslotValueDto[] | undefined;
}

export interface VariableToUnslotValueDto {
    index?: number;
    label: string;
    fieldText: string;
}

export interface UnslotSpecStatusDto {
    state?: UnslotSpecStatus;
    token?: string | undefined;
    message?: string | undefined;
    error?: string | undefined;
}

export enum UnslotSpecStatus {
    InProgress = "InProgress",
    Failed = "Failed",
    Complete = "Complete",
    Success = "Success",
    Unknown = "Unknown",
}

export interface UnslotSpecHistoryDto {
    unslotSpecName?: string | undefined;
    unslotSpecId?: string | undefined;
}

export interface UnslotSpecFormDataDto {
    unslotSpecName?: string | undefined;
    unslotSpecId?: string | undefined;
    numOfSlotVariables?: number;
    slotVariables?: string[] | undefined;
    brands?: string[] | undefined;
    variablesToUnslot?: VariableToUnslotValueDto[] | undefined;
}

export interface VariableCategoriesListDto {
    variableName?: string | undefined;
    variableCategories?: VariableCategoryDto[] | undefined;
}

export interface ScalarVariableStatsDto {
    base?: number;
    mean?: number;
    std?: number;
    min?: number;
    max?: number;
    p25?: number;
    p50?: number;
    p75?: number;
    plotValues?: PointDto[] | undefined;
    cutPoints?: CutPointStatsDto[] | undefined;
}

export interface PointDto {
    x: number;
    y: number;
}

export interface CutPointStatsDto {
    splitValues: number[];
    populations: number[];
}

export interface CategoricalVariableStatsDto {
    base: number;
    uniqueCodes: number;
    modalCode: number;
    codeCounts: { [key: string]: number; };
}

export interface GetAllVariablesQuery {
    projectId: number;
    encodedVersionId: string;
    batteries?: string[] | undefined;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    requestedType?: VariableTypes | undefined;
}

export interface GetAllDatasetVariablesQuery {
    projectId: number;
    encodedVersionId: string;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    requestedType?: VariableTypes | undefined;
}

export interface VariableNameBatteryDto {
    name: string;
    variableFullName: string;
    battery: string;
    datatype: DataTypes;
    variableLabel?: string | undefined;
}

export interface GetVariableNameBatteryListQuery {
    projectId: number;
    encodedVersionId: string;
    batteries?: string[] | undefined;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    requestedType?: VariableTypes | undefined;
}

export interface GetDatasetVariableNameBatteryQuery {
    projectId: number;
    encodedVersionId: string;
    modificationId?: number | undefined;
    stackId?: number | undefined;
    requestedType?: VariableTypes | undefined;
    applyFilter?: boolean;
}

export interface VariableStemDto {
    stem: string;
    name: string;
    variableLabel?: string | undefined;
    friendlyName: string;
}

export interface AssignerHintsDto {
    high?: AssignerVariableDto[] | undefined;
    medium?: AssignerVariableDto[] | undefined;
    low?: AssignerVariableDto[] | undefined;
}

export interface AssignerVariableDto {
    battery?: string | undefined;
    variableFullName?: string | undefined;
}

export interface RecodeDto {
    createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
    validationStatus?: InstructionValidationStatuses;
}

export interface RecodeVariableCommand {
    batteryOriginName: string;
    variableCategories?: VariableCategoryDto[] | undefined;
    quantileSplitCount?: number | undefined;
    recodeName: string;
    environment?: string | undefined;
    modificationId: number;
    projectId: number;
    versionId: string;
}

export interface EditedVariablesDto {
    variables?: VariableDto[] | undefined;
    createCustomEmailNotificationDto?: CreateCustomEmailNotificationDto | undefined;
    validationStatus?: InstructionValidationStatuses;
}

export interface EditDisplayLabelsCommand {
    modificationId: number;
    editedLabels: EditableVariableCategoryLabelDto[];
    projectId: number;
    versionId: string;
    environment?: string | undefined;
}

export interface EditableVariableCategoryLabelDto {
    variableFriendlyName: string;
    displayLabel?: string | undefined;
    displayLabelLevel2?: string | undefined;
}

export interface ResetVariableChangesCommand {
    variableFriendlyName: string;
    modificationId: number;
}

export interface StackablesDto {
    stackableBatteries: OriginBatteryDto[];
    stackableVariables: VariableStemDto[];
}

export interface WalrProjectDto {
    id?: number;
    workdayId?: string | undefined;
    name?: string | undefined;
    originProjectId?: string | undefined;
    externalProjectId?: string | undefined;
    isDatasetExists?: boolean;
}

export interface CreateWalrProjectCommand {
    datasetName: string;
    datasetId: string;
    projectId: string;
    workdayProjectId?: number | undefined;
}

export interface WorkdayProjectDto {
    id?: number;
    name?: string | undefined;
    client?: string | undefined;
    workdayId?: string | undefined;
    costCenter?: string | undefined;
    workdayProjectType?: WorkdayProjectType;
    isStarred?: boolean;
    createdBy?: User | undefined;
    createdAt?: string;
    modifiedBy?: User | undefined;
    modifiedAt?: string | undefined;
}

export enum WorkdayProjectType {
    Tracker = "Tracker",
    Adhoc = "Adhoc",
}

export interface BaseEntityOfInteger {
    id?: number;
}

export interface User extends BaseEntityOfInteger {
    userName?: string | undefined;
    normalizedUserName?: string | undefined;
    firstName?: string | undefined;
    lastName?: string | undefined;
}

export interface CreateWorkdayProjectCommand {
    name: string;
    client?: string | undefined;
    workdayId: string;
    costCenter?: string | undefined;
    workdayProjectType?: WorkdayProjectType;
}

export interface UpdateWorkdayProjectStarCommand {
    workdayProjectId?: number;
    isStarred?: boolean;
}

export interface UpdateWorkdayProjectCommand {
    id?: number;
    name: string;
    client?: string | undefined;
    workdayId: string;
    costCenter?: string | undefined;
    workdayProjectType?: WorkdayProjectType;
}

export interface WorkdayProjectDatasetDto {
    id?: number;
    versionId?: string | undefined;
    isDatasetExists?: boolean;
}

export interface CreateWorkdayProjectDatasetCommand {
    originProjectId: string;
    originProjectName?: string | undefined;
    environmentKey?: string | undefined;
    sourceId: number;
    sourceCode?: string | undefined;
    workdayProjectId: number;
}

export interface WorkdayDatasetDto {
    id?: number;
    originProjectId?: string | undefined;
    name?: string | undefined;
    originSource?: string | undefined;
    normalizedDataSource?: string | undefined;
    versionDate?: string;
    normalizedVersionDate?: string | undefined;
    iconTag?: string | undefined;
    workdayId?: string | undefined;
    status?: WorkdayProjectDatasetStatus;
}

export interface UpdateWorkdayDatasetStatusCommand {
    workdayDatasetId?: number;
    status?: WorkdayProjectDatasetStatus;
    workdayProjectId?: number;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

const INTERGTRATION_API_ERROR_CDOE = 527;
export const INTERGTRATION_API_ERROR_NOTIFICATION = "LRWApiErrorNotification";

export type IntegrationApiErrorRespponse = {
  response: string;
  request: string;
  errorMessage: string;
  url?: string;
};